/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * Mooya Dealer Portal API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountActivationStatus,
  AccountActivationVerifyBody,
  AccountManager,
  AccountManagerDashboard,
  AccountManagerInput,
  AccountManagerUpdate,
  AdminDashboard,
  AdminUserUpdate,
  Agent,
  AgentCommissionPlanUpdate,
  AgentCompliance,
  AgentDashboard,
  AgentInput,
  AgentNotifications,
  AgentTraining,
  AgentUpdate,
  Application,
  ApplicationInput,
  ApplicationUpdate,
  Area,
  AreaInput,
  BankChangeRequest,
  BankChangeRequestInput,
  BankChangeRequestUpdate,
  BankChangeVerificationStatus,
  BankChangeVerifyBody,
  CommissionPlan,
  CompleteProfileBody,
  CreateInvitationResponse,
  CurrentUser,
  DataImport,
  DataImportInput,
  Dispute,
  DisputeInput,
  DisputeUpdate,
  EftExportResult,
  Error,
  FailPaymentRunInput,
  FinanceDashboard,
  ForbiddenResponse,
  HealthStatus,
  ImportOrderChange,
  InfoSession,
  InfoSessionInput,
  InfoSessionUpdate,
  Invitation,
  InvitationInput,
  InvitationUpdate,
  ListAccountManagersParams,
  ListAdminUsers200,
  ListAdminUsersParams,
  ListAgents200,
  ListAgentsParams,
  ListApplications200,
  ListApplicationsParams,
  ListAreasParams,
  ListAuditLogs200,
  ListAuditLogsParams,
  ListBankChangeRequestsParams,
  ListCommissionPlans200,
  ListDataImports200,
  ListDataImportsParams,
  ListDisputes200,
  ListDisputesParams,
  ListInfoSessions200,
  ListInfoSessionsParams,
  ListInvitations200,
  ListInvitationsParams,
  ListMarketingMaterials200,
  ListMarketingMaterialsParams,
  ListMasterDealers200,
  ListMasterDealersParams,
  ListOnboardingReviewsParams,
  ListOrders200,
  ListOrdersParams,
  ListStaffInvitations200,
  ListTickets200,
  ListTicketsParams,
  ListTransactions200,
  ListTransactionsParams,
  LmsAssessmentInput,
  LmsAssessmentResult,
  LmsExam,
  LmsProgress,
  LmsProgressInput,
  MarketingMaterial,
  MarketingMaterialInput,
  MasterDealer,
  MasterDealerDashboard,
  MasterDealerInput,
  MasterDealerUpdate,
  MsaSendResult,
  MsaSignBody,
  MsaStatus,
  NotFoundResponse,
  Notification,
  NotifyAgentsResult,
  Onboarding,
  OnboardingFunnel,
  OnboardingReview,
  OnboardingReviewUpdate,
  Order,
  OrderInput,
  OrderUpdate,
  PaymentRun,
  PaymentRunDetail,
  PaymentRunInput,
  PaymentRunUpdate,
  ProcessDataImportInput,
  ProcessDataImportResult,
  ReconcilePaymentRunInput,
  ReconcilePaymentRunResult,
  Region,
  RegionInput,
  RegionUpdate,
  RoleUpdate,
  StaffInvitationResult,
  StaffInviteInput,
  StartAccountActivationBody,
  SupportDashboard,
  Ticket,
  TicketAssignee,
  TicketDetail,
  TicketInput,
  TicketMessage,
  TicketMessageInput,
  TicketUpdate,
  Transaction,
  TransactionInput,
  UnauthorizedResponse,
  UpdateCommissionRatesInput,
  UpdateOnboardingBody,
  UploadUrlRequest,
  UploadUrlResponse,
  Wallet
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMeUrl = () => {




  return `/api/me`
}

/**
 * @summary Get the current authenticated user
 */
export const getMe = async ( options?: RequestInit): Promise<CurrentUser> => {

  return customFetch<CurrentUser>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Get the current authenticated user
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateMyRoleUrl = () => {




  return `/api/me/role`
}

/**
 * @summary Update the current user's active role (demo/preview affordance)
 */
export const updateMyRole = async (roleUpdate: RoleUpdate, options?: RequestInit): Promise<CurrentUser> => {

  return customFetch<CurrentUser>(getUpdateMyRoleUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roleUpdate,)
  }
);}




export const getUpdateMyRoleMutationOptions = <TError = ErrorType<UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyRole>>, TError,{data: BodyType<RoleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyRole>>, TError,{data: BodyType<RoleUpdate>}, TContext> => {

const mutationKey = ['updateMyRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyRole>>, {data: BodyType<RoleUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateMyRole(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyRole>>>
    export type UpdateMyRoleMutationBody = BodyType<RoleUpdate>
    export type UpdateMyRoleMutationError = ErrorType<UnauthorizedResponse>

    /**
 * @summary Update the current user's active role (demo/preview affordance)
 */
export const useUpdateMyRole = <TError = ErrorType<UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyRole>>, TError,{data: BodyType<RoleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMyRole>>,
        TError,
        {data: BodyType<RoleUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMyRoleMutationOptions(options));
    }

export const getGetMyActivationUrl = () => {




  return `/api/me/activation`
}

/**
 * @summary Get the current user's account-activation status
 */
export const getMyActivation = async ( options?: RequestInit): Promise<AccountActivationStatus> => {

  return customFetch<AccountActivationStatus>(getGetMyActivationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyActivationQueryKey = () => {
    return [
    `/api/me/activation`
    ] as const;
    }


export const getGetMyActivationQueryOptions = <TData = Awaited<ReturnType<typeof getMyActivation>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyActivation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyActivationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyActivation>>> = ({ signal }) => getMyActivation({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyActivation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyActivationQueryResult = NonNullable<Awaited<ReturnType<typeof getMyActivation>>>
export type GetMyActivationQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Get the current user's account-activation status
 */

export function useGetMyActivation<TData = Awaited<ReturnType<typeof getMyActivation>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyActivation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyActivationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRequestAccountActivationUrl = () => {




  return `/api/me/activation/request`
}

/**
 * @summary Start a dual-channel (SMS + email) OTP session to activate the account
 */
export const requestAccountActivation = async (startAccountActivationBody: StartAccountActivationBody, options?: RequestInit): Promise<AccountActivationStatus> => {

  return customFetch<AccountActivationStatus>(getRequestAccountActivationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startAccountActivationBody,)
  }
);}




export const getRequestAccountActivationMutationOptions = <TError = ErrorType<Error | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAccountActivation>>, TError,{data: BodyType<StartAccountActivationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestAccountActivation>>, TError,{data: BodyType<StartAccountActivationBody>}, TContext> => {

const mutationKey = ['requestAccountActivation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestAccountActivation>>, {data: BodyType<StartAccountActivationBody>}> = (props) => {
          const {data} = props ?? {};

          return  requestAccountActivation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestAccountActivationMutationResult = NonNullable<Awaited<ReturnType<typeof requestAccountActivation>>>
    export type RequestAccountActivationMutationBody = BodyType<StartAccountActivationBody>
    export type RequestAccountActivationMutationError = ErrorType<Error | UnauthorizedResponse>

    /**
 * @summary Start a dual-channel (SMS + email) OTP session to activate the account
 */
export const useRequestAccountActivation = <TError = ErrorType<Error | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAccountActivation>>, TError,{data: BodyType<StartAccountActivationBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestAccountActivation>>,
        TError,
        {data: BodyType<StartAccountActivationBody>},
        TContext
      > => {
      return useMutation(getRequestAccountActivationMutationOptions(options));
    }

export const getVerifyAccountActivationUrl = () => {




  return `/api/me/activation/verify`
}

/**
 * @summary Verify one channel's OTP code for the current activation session
 */
export const verifyAccountActivation = async (accountActivationVerifyBody: AccountActivationVerifyBody, options?: RequestInit): Promise<AccountActivationStatus> => {

  return customFetch<AccountActivationStatus>(getVerifyAccountActivationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountActivationVerifyBody,)
  }
);}




export const getVerifyAccountActivationMutationOptions = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyAccountActivation>>, TError,{data: BodyType<AccountActivationVerifyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyAccountActivation>>, TError,{data: BodyType<AccountActivationVerifyBody>}, TContext> => {

const mutationKey = ['verifyAccountActivation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyAccountActivation>>, {data: BodyType<AccountActivationVerifyBody>}> = (props) => {
          const {data} = props ?? {};

          return  verifyAccountActivation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyAccountActivationMutationResult = NonNullable<Awaited<ReturnType<typeof verifyAccountActivation>>>
    export type VerifyAccountActivationMutationBody = BodyType<AccountActivationVerifyBody>
    export type VerifyAccountActivationMutationError = ErrorType<Error | NotFoundResponse>

    /**
 * @summary Verify one channel's OTP code for the current activation session
 */
export const useVerifyAccountActivation = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyAccountActivation>>, TError,{data: BodyType<AccountActivationVerifyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyAccountActivation>>,
        TError,
        {data: BodyType<AccountActivationVerifyBody>},
        TContext
      > => {
      return useMutation(getVerifyAccountActivationMutationOptions(options));
    }

export const getCompleteMyProfileUrl = () => {




  return `/api/me/profile`
}

/**
 * @summary Complete the internal-staff / account-manager profile
 */
export const completeMyProfile = async (completeProfileBody: CompleteProfileBody, options?: RequestInit): Promise<CurrentUser> => {

  return customFetch<CurrentUser>(getCompleteMyProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      completeProfileBody,)
  }
);}




export const getCompleteMyProfileMutationOptions = <TError = ErrorType<Error | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeMyProfile>>, TError,{data: BodyType<CompleteProfileBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeMyProfile>>, TError,{data: BodyType<CompleteProfileBody>}, TContext> => {

const mutationKey = ['completeMyProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeMyProfile>>, {data: BodyType<CompleteProfileBody>}> = (props) => {
          const {data} = props ?? {};

          return  completeMyProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteMyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof completeMyProfile>>>
    export type CompleteMyProfileMutationBody = BodyType<CompleteProfileBody>
    export type CompleteMyProfileMutationError = ErrorType<Error | UnauthorizedResponse>

    /**
 * @summary Complete the internal-staff / account-manager profile
 */
export const useCompleteMyProfile = <TError = ErrorType<Error | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeMyProfile>>, TError,{data: BodyType<CompleteProfileBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeMyProfile>>,
        TError,
        {data: BodyType<CompleteProfileBody>},
        TContext
      > => {
      return useMutation(getCompleteMyProfileMutationOptions(options));
    }

export const getListUsersUrl = () => {




  return `/api/users`
}

/**
 * @summary List all portal users (admin only)
 */
export const listUsers = async ( options?: RequestInit): Promise<CurrentUser[]> => {

  return customFetch<CurrentUser[]>(getListUsersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersQueryKey = () => {
    return [
    `/api/users`
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse>


/**
 * @summary List all portal users (admin only)
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUsersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateUserRoleUrl = (id: number,) => {




  return `/api/users/${id}/role`
}

/**
 * @summary Assign or change a user's role (admin only)
 */
export const updateUserRole = async (id: number,
    roleUpdate: RoleUpdate, options?: RequestInit): Promise<CurrentUser> => {

  return customFetch<CurrentUser>(getUpdateUserRoleUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roleUpdate,)
  }
);}




export const getUpdateUserRoleMutationOptions = <TError = ErrorType<Error | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserRole>>, TError,{id: number;data: BodyType<RoleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserRole>>, TError,{id: number;data: BodyType<RoleUpdate>}, TContext> => {

const mutationKey = ['updateUserRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserRole>>, {id: number;data: BodyType<RoleUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUserRole(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserRole>>>
    export type UpdateUserRoleMutationBody = BodyType<RoleUpdate>
    export type UpdateUserRoleMutationError = ErrorType<Error | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Assign or change a user's role (admin only)
 */
export const useUpdateUserRole = <TError = ErrorType<Error | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserRole>>, TError,{id: number;data: BodyType<RoleUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUserRole>>,
        TError,
        {id: number;data: BodyType<RoleUpdate>},
        TContext
      > => {
      return useMutation(getUpdateUserRoleMutationOptions(options));
    }

export const getListAdminUsersUrl = (params?: ListAdminUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/users?${stringifiedParams}` : `/api/admin/users`
}

/**
 * @summary List internal staff users (admin only)
 */
export const listAdminUsers = async (params?: ListAdminUsersParams, options?: RequestInit): Promise<ListAdminUsers200> => {

  return customFetch<ListAdminUsers200>(getListAdminUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminUsersQueryKey = (params?: ListAdminUsersParams,) => {
    return [
    `/api/admin/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminUsersQueryOptions = <TData = Awaited<ReturnType<typeof listAdminUsers>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>>(params?: ListAdminUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminUsers>>> = ({ signal }) => listAdminUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminUsers>>>
export type ListAdminUsersQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse>


/**
 * @summary List internal staff users (admin only)
 */

export function useListAdminUsers<TData = Awaited<ReturnType<typeof listAdminUsers>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>>(
 params?: ListAdminUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getInviteStaffUrl = () => {




  return `/api/admin/users/invite`
}

/**
 * @summary Invite an internal staff member (admin only)
 */
export const inviteStaff = async (staffInviteInput: StaffInviteInput, options?: RequestInit): Promise<StaffInvitationResult> => {

  return customFetch<StaffInvitationResult>(getInviteStaffUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      staffInviteInput,)
  }
);}




export const getInviteStaffMutationOptions = <TError = ErrorType<Error | UnauthorizedResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteStaff>>, TError,{data: BodyType<StaffInviteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteStaff>>, TError,{data: BodyType<StaffInviteInput>}, TContext> => {

const mutationKey = ['inviteStaff'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteStaff>>, {data: BodyType<StaffInviteInput>}> = (props) => {
          const {data} = props ?? {};

          return  inviteStaff(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteStaffMutationResult = NonNullable<Awaited<ReturnType<typeof inviteStaff>>>
    export type InviteStaffMutationBody = BodyType<StaffInviteInput>
    export type InviteStaffMutationError = ErrorType<Error | UnauthorizedResponse | ForbiddenResponse>

    /**
 * @summary Invite an internal staff member (admin only)
 */
export const useInviteStaff = <TError = ErrorType<Error | UnauthorizedResponse | ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteStaff>>, TError,{data: BodyType<StaffInviteInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof inviteStaff>>,
        TError,
        {data: BodyType<StaffInviteInput>},
        TContext
      > => {
      return useMutation(getInviteStaffMutationOptions(options));
    }

export const getListStaffInvitationsUrl = () => {




  return `/api/admin/users/invitations`
}

/**
 * @summary List outstanding staff invitations (admin only)
 */
export const listStaffInvitations = async ( options?: RequestInit): Promise<ListStaffInvitations200> => {

  return customFetch<ListStaffInvitations200>(getListStaffInvitationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStaffInvitationsQueryKey = () => {
    return [
    `/api/admin/users/invitations`
    ] as const;
    }


export const getListStaffInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listStaffInvitations>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStaffInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStaffInvitationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStaffInvitations>>> = ({ signal }) => listStaffInvitations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStaffInvitations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListStaffInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listStaffInvitations>>>
export type ListStaffInvitationsQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse>


/**
 * @summary List outstanding staff invitations (admin only)
 */

export function useListStaffInvitations<TData = Awaited<ReturnType<typeof listStaffInvitations>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listStaffInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListStaffInvitationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateAdminUserUrl = (id: number,) => {




  return `/api/admin/users/${id}`
}

/**
 * @summary Update a staff user's role, status, or personal details (admin only)
 */
export const updateAdminUser = async (id: number,
    adminUserUpdate: AdminUserUpdate, options?: RequestInit): Promise<CurrentUser> => {

  return customFetch<CurrentUser>(getUpdateAdminUserUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminUserUpdate,)
  }
);}




export const getUpdateAdminUserMutationOptions = <TError = ErrorType<Error | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminUser>>, TError,{id: number;data: BodyType<AdminUserUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminUser>>, TError,{id: number;data: BodyType<AdminUserUpdate>}, TContext> => {

const mutationKey = ['updateAdminUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminUser>>, {id: number;data: BodyType<AdminUserUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAdminUser(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminUser>>>
    export type UpdateAdminUserMutationBody = BodyType<AdminUserUpdate>
    export type UpdateAdminUserMutationError = ErrorType<Error | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Update a staff user's role, status, or personal details (admin only)
 */
export const useUpdateAdminUser = <TError = ErrorType<Error | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminUser>>, TError,{id: number;data: BodyType<AdminUserUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminUser>>,
        TError,
        {id: number;data: BodyType<AdminUserUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAdminUserMutationOptions(options));
    }

export const getGetAgentDashboardUrl = () => {




  return `/api/dashboard/agent`
}

/**
 * @summary Agent home dashboard summary
 */
export const getAgentDashboard = async ( options?: RequestInit): Promise<AgentDashboard> => {

  return customFetch<AgentDashboard>(getGetAgentDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgentDashboardQueryKey = () => {
    return [
    `/api/dashboard/agent`
    ] as const;
    }


export const getGetAgentDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getAgentDashboard>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentDashboard>>> = ({ signal }) => getAgentDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgentDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentDashboard>>>
export type GetAgentDashboardQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Agent home dashboard summary
 */

export function useGetAgentDashboard<TData = Awaited<ReturnType<typeof getAgentDashboard>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgentDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMasterDealerDashboardUrl = () => {




  return `/api/dashboard/master-dealer`
}

/**
 * @summary Master dealer home dashboard summary
 */
export const getMasterDealerDashboard = async ( options?: RequestInit): Promise<MasterDealerDashboard> => {

  return customFetch<MasterDealerDashboard>(getGetMasterDealerDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMasterDealerDashboardQueryKey = () => {
    return [
    `/api/dashboard/master-dealer`
    ] as const;
    }


export const getGetMasterDealerDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getMasterDealerDashboard>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMasterDealerDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMasterDealerDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMasterDealerDashboard>>> = ({ signal }) => getMasterDealerDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMasterDealerDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMasterDealerDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getMasterDealerDashboard>>>
export type GetMasterDealerDashboardQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Master dealer home dashboard summary
 */

export function useGetMasterDealerDashboard<TData = Awaited<ReturnType<typeof getMasterDealerDashboard>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMasterDealerDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMasterDealerDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAccountManagerDashboardUrl = () => {




  return `/api/dashboard/account-manager`
}

/**
 * @summary Account manager home dashboard summary
 */
export const getAccountManagerDashboard = async ( options?: RequestInit): Promise<AccountManagerDashboard> => {

  return customFetch<AccountManagerDashboard>(getGetAccountManagerDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountManagerDashboardQueryKey = () => {
    return [
    `/api/dashboard/account-manager`
    ] as const;
    }


export const getGetAccountManagerDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getAccountManagerDashboard>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountManagerDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountManagerDashboard>>> = ({ signal }) => getAccountManagerDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountManagerDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountManagerDashboard>>>
export type GetAccountManagerDashboardQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Account manager home dashboard summary
 */

export function useGetAccountManagerDashboard<TData = Awaited<ReturnType<typeof getAccountManagerDashboard>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountManagerDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountManagerDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAdminDashboardUrl = () => {




  return `/api/dashboard/admin`
}

/**
 * @summary Internal reviewer / admin home dashboard summary
 */
export const getAdminDashboard = async ( options?: RequestInit): Promise<AdminDashboard> => {

  return customFetch<AdminDashboard>(getGetAdminDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminDashboardQueryKey = () => {
    return [
    `/api/dashboard/admin`
    ] as const;
    }


export const getGetAdminDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDashboard>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDashboard>>> = ({ signal }) => getAdminDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDashboard>>>
export type GetAdminDashboardQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Internal reviewer / admin home dashboard summary
 */

export function useGetAdminDashboard<TData = Awaited<ReturnType<typeof getAdminDashboard>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetOperationsDashboardUrl = () => {




  return `/api/dashboard/operations`
}

/**
 * @summary Operations home dashboard summary (application review queue)
 */
export const getOperationsDashboard = async ( options?: RequestInit): Promise<AdminDashboard> => {

  return customFetch<AdminDashboard>(getGetOperationsDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOperationsDashboardQueryKey = () => {
    return [
    `/api/dashboard/operations`
    ] as const;
    }


export const getGetOperationsDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getOperationsDashboard>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOperationsDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOperationsDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOperationsDashboard>>> = ({ signal }) => getOperationsDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOperationsDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOperationsDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getOperationsDashboard>>>
export type GetOperationsDashboardQueryError = ErrorType<UnauthorizedResponse | ForbiddenResponse>


/**
 * @summary Operations home dashboard summary (application review queue)
 */

export function useGetOperationsDashboard<TData = Awaited<ReturnType<typeof getOperationsDashboard>>, TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOperationsDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOperationsDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetFinanceDashboardUrl = () => {




  return `/api/dashboard/finance`
}

/**
 * @summary Finance home dashboard summary
 */
export const getFinanceDashboard = async ( options?: RequestInit): Promise<FinanceDashboard> => {

  return customFetch<FinanceDashboard>(getGetFinanceDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFinanceDashboardQueryKey = () => {
    return [
    `/api/dashboard/finance`
    ] as const;
    }


export const getGetFinanceDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getFinanceDashboard>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFinanceDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFinanceDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFinanceDashboard>>> = ({ signal }) => getFinanceDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFinanceDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFinanceDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getFinanceDashboard>>>
export type GetFinanceDashboardQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Finance home dashboard summary
 */

export function useGetFinanceDashboard<TData = Awaited<ReturnType<typeof getFinanceDashboard>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFinanceDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFinanceDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetSupportDashboardUrl = () => {




  return `/api/dashboard/poc_support`
}

/**
 * @summary Support home dashboard summary
 */
export const getSupportDashboard = async ( options?: RequestInit): Promise<SupportDashboard> => {

  return customFetch<SupportDashboard>(getGetSupportDashboardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSupportDashboardQueryKey = () => {
    return [
    `/api/dashboard/poc_support`
    ] as const;
    }


export const getGetSupportDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getSupportDashboard>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportDashboard>>> = ({ signal }) => getSupportDashboard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupportDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportDashboard>>>
export type GetSupportDashboardQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Support home dashboard summary
 */

export function useGetSupportDashboard<TData = Awaited<ReturnType<typeof getSupportDashboard>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportDashboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupportDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetOnboardingFunnelUrl = () => {




  return `/api/dashboard/onboarding-funnel`
}

/**
 * @summary Onboarding funnel analytics (admin / account manager)
 */
export const getOnboardingFunnel = async ( options?: RequestInit): Promise<OnboardingFunnel> => {

  return customFetch<OnboardingFunnel>(getGetOnboardingFunnelUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOnboardingFunnelQueryKey = () => {
    return [
    `/api/dashboard/onboarding-funnel`
    ] as const;
    }


export const getGetOnboardingFunnelQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingFunnel>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOnboardingFunnel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingFunnelQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingFunnel>>> = ({ signal }) => getOnboardingFunnel({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingFunnel>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOnboardingFunnelQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingFunnel>>>
export type GetOnboardingFunnelQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Onboarding funnel analytics (admin / account manager)
 */

export function useGetOnboardingFunnel<TData = Awaited<ReturnType<typeof getOnboardingFunnel>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOnboardingFunnel>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOnboardingFunnelQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListRegionsUrl = () => {




  return `/api/regions`
}

/**
 * @summary List regions
 */
export const listRegions = async ( options?: RequestInit): Promise<Region[]> => {

  return customFetch<Region[]>(getListRegionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRegionsQueryKey = () => {
    return [
    `/api/regions`
    ] as const;
    }


export const getListRegionsQueryOptions = <TData = Awaited<ReturnType<typeof listRegions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRegions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRegionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRegions>>> = ({ signal }) => listRegions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRegions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRegionsQueryResult = NonNullable<Awaited<ReturnType<typeof listRegions>>>
export type ListRegionsQueryError = ErrorType<unknown>


/**
 * @summary List regions
 */

export function useListRegions<TData = Awaited<ReturnType<typeof listRegions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRegions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRegionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateRegionUrl = () => {




  return `/api/regions`
}

/**
 * @summary Create a region
 */
export const createRegion = async (regionInput: RegionInput, options?: RequestInit): Promise<Region> => {

  return customFetch<Region>(getCreateRegionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      regionInput,)
  }
);}




export const getCreateRegionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRegion>>, TError,{data: BodyType<RegionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRegion>>, TError,{data: BodyType<RegionInput>}, TContext> => {

const mutationKey = ['createRegion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRegion>>, {data: BodyType<RegionInput>}> = (props) => {
          const {data} = props ?? {};

          return  createRegion(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRegionMutationResult = NonNullable<Awaited<ReturnType<typeof createRegion>>>
    export type CreateRegionMutationBody = BodyType<RegionInput>
    export type CreateRegionMutationError = ErrorType<unknown>

    /**
 * @summary Create a region
 */
export const useCreateRegion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRegion>>, TError,{data: BodyType<RegionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRegion>>,
        TError,
        {data: BodyType<RegionInput>},
        TContext
      > => {
      return useMutation(getCreateRegionMutationOptions(options));
    }

export const getGetRegionUrl = (id: number,) => {




  return `/api/regions/${id}`
}

/**
 * @summary Get a region
 */
export const getRegion = async (id: number, options?: RequestInit): Promise<Region> => {

  return customFetch<Region>(getGetRegionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRegionQueryKey = (id: number,) => {
    return [
    `/api/regions/${id}`
    ] as const;
    }


export const getGetRegionQueryOptions = <TData = Awaited<ReturnType<typeof getRegion>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegion>>> = ({ signal }) => getRegion(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegionQueryResult = NonNullable<Awaited<ReturnType<typeof getRegion>>>
export type GetRegionQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get a region
 */

export function useGetRegion<TData = Awaited<ReturnType<typeof getRegion>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRegionQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateRegionUrl = (id: number,) => {




  return `/api/regions/${id}`
}

/**
 * @summary Update a region
 */
export const updateRegion = async (id: number,
    regionUpdate: RegionUpdate, options?: RequestInit): Promise<Region> => {

  return customFetch<Region>(getUpdateRegionUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      regionUpdate,)
  }
);}




export const getUpdateRegionMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRegion>>, TError,{id: number;data: BodyType<RegionUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRegion>>, TError,{id: number;data: BodyType<RegionUpdate>}, TContext> => {

const mutationKey = ['updateRegion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRegion>>, {id: number;data: BodyType<RegionUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRegion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRegionMutationResult = NonNullable<Awaited<ReturnType<typeof updateRegion>>>
    export type UpdateRegionMutationBody = BodyType<RegionUpdate>
    export type UpdateRegionMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Update a region
 */
export const useUpdateRegion = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRegion>>, TError,{id: number;data: BodyType<RegionUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRegion>>,
        TError,
        {id: number;data: BodyType<RegionUpdate>},
        TContext
      > => {
      return useMutation(getUpdateRegionMutationOptions(options));
    }

export const getListAreasUrl = (params?: ListAreasParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/areas?${stringifiedParams}` : `/api/areas`
}

/**
 * @summary List areas
 */
export const listAreas = async (params?: ListAreasParams, options?: RequestInit): Promise<Area[]> => {

  return customFetch<Area[]>(getListAreasUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAreasQueryKey = (params?: ListAreasParams,) => {
    return [
    `/api/areas`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAreasQueryOptions = <TData = Awaited<ReturnType<typeof listAreas>>, TError = ErrorType<unknown>>(params?: ListAreasParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAreas>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAreasQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAreas>>> = ({ signal }) => listAreas(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAreas>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAreasQueryResult = NonNullable<Awaited<ReturnType<typeof listAreas>>>
export type ListAreasQueryError = ErrorType<unknown>


/**
 * @summary List areas
 */

export function useListAreas<TData = Awaited<ReturnType<typeof listAreas>>, TError = ErrorType<unknown>>(
 params?: ListAreasParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAreas>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAreasQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAreaUrl = () => {




  return `/api/areas`
}

/**
 * @summary Create an area
 */
export const createArea = async (areaInput: AreaInput, options?: RequestInit): Promise<Area> => {

  return customFetch<Area>(getCreateAreaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      areaInput,)
  }
);}




export const getCreateAreaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArea>>, TError,{data: BodyType<AreaInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createArea>>, TError,{data: BodyType<AreaInput>}, TContext> => {

const mutationKey = ['createArea'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createArea>>, {data: BodyType<AreaInput>}> = (props) => {
          const {data} = props ?? {};

          return  createArea(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAreaMutationResult = NonNullable<Awaited<ReturnType<typeof createArea>>>
    export type CreateAreaMutationBody = BodyType<AreaInput>
    export type CreateAreaMutationError = ErrorType<unknown>

    /**
 * @summary Create an area
 */
export const useCreateArea = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArea>>, TError,{data: BodyType<AreaInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createArea>>,
        TError,
        {data: BodyType<AreaInput>},
        TContext
      > => {
      return useMutation(getCreateAreaMutationOptions(options));
    }

export const getListMasterDealersUrl = (params?: ListMasterDealersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/master-dealers?${stringifiedParams}` : `/api/master-dealers`
}

/**
 * @summary List master dealers
 */
export const listMasterDealers = async (params?: ListMasterDealersParams, options?: RequestInit): Promise<ListMasterDealers200> => {

  return customFetch<ListMasterDealers200>(getListMasterDealersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMasterDealersQueryKey = (params?: ListMasterDealersParams,) => {
    return [
    `/api/master-dealers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMasterDealersQueryOptions = <TData = Awaited<ReturnType<typeof listMasterDealers>>, TError = ErrorType<unknown>>(params?: ListMasterDealersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMasterDealers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMasterDealersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMasterDealers>>> = ({ signal }) => listMasterDealers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMasterDealers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMasterDealersQueryResult = NonNullable<Awaited<ReturnType<typeof listMasterDealers>>>
export type ListMasterDealersQueryError = ErrorType<unknown>


/**
 * @summary List master dealers
 */

export function useListMasterDealers<TData = Awaited<ReturnType<typeof listMasterDealers>>, TError = ErrorType<unknown>>(
 params?: ListMasterDealersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMasterDealers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMasterDealersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateMasterDealerUrl = () => {




  return `/api/master-dealers`
}

/**
 * @summary Create a master dealer
 */
export const createMasterDealer = async (masterDealerInput: MasterDealerInput, options?: RequestInit): Promise<MasterDealer> => {

  return customFetch<MasterDealer>(getCreateMasterDealerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      masterDealerInput,)
  }
);}




export const getCreateMasterDealerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMasterDealer>>, TError,{data: BodyType<MasterDealerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMasterDealer>>, TError,{data: BodyType<MasterDealerInput>}, TContext> => {

const mutationKey = ['createMasterDealer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMasterDealer>>, {data: BodyType<MasterDealerInput>}> = (props) => {
          const {data} = props ?? {};

          return  createMasterDealer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMasterDealerMutationResult = NonNullable<Awaited<ReturnType<typeof createMasterDealer>>>
    export type CreateMasterDealerMutationBody = BodyType<MasterDealerInput>
    export type CreateMasterDealerMutationError = ErrorType<unknown>

    /**
 * @summary Create a master dealer
 */
export const useCreateMasterDealer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMasterDealer>>, TError,{data: BodyType<MasterDealerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMasterDealer>>,
        TError,
        {data: BodyType<MasterDealerInput>},
        TContext
      > => {
      return useMutation(getCreateMasterDealerMutationOptions(options));
    }

export const getGetMasterDealerUrl = (id: number,) => {




  return `/api/master-dealers/${id}`
}

/**
 * @summary Get a master dealer
 */
export const getMasterDealer = async (id: number, options?: RequestInit): Promise<MasterDealer> => {

  return customFetch<MasterDealer>(getGetMasterDealerUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMasterDealerQueryKey = (id: number,) => {
    return [
    `/api/master-dealers/${id}`
    ] as const;
    }


export const getGetMasterDealerQueryOptions = <TData = Awaited<ReturnType<typeof getMasterDealer>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMasterDealer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMasterDealerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMasterDealer>>> = ({ signal }) => getMasterDealer(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMasterDealer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMasterDealerQueryResult = NonNullable<Awaited<ReturnType<typeof getMasterDealer>>>
export type GetMasterDealerQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get a master dealer
 */

export function useGetMasterDealer<TData = Awaited<ReturnType<typeof getMasterDealer>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMasterDealer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMasterDealerQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateMasterDealerUrl = (id: number,) => {




  return `/api/master-dealers/${id}`
}

/**
 * @summary Update a master dealer
 */
export const updateMasterDealer = async (id: number,
    masterDealerUpdate: MasterDealerUpdate, options?: RequestInit): Promise<MasterDealer> => {

  return customFetch<MasterDealer>(getUpdateMasterDealerUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      masterDealerUpdate,)
  }
);}




export const getUpdateMasterDealerMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMasterDealer>>, TError,{id: number;data: BodyType<MasterDealerUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMasterDealer>>, TError,{id: number;data: BodyType<MasterDealerUpdate>}, TContext> => {

const mutationKey = ['updateMasterDealer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMasterDealer>>, {id: number;data: BodyType<MasterDealerUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateMasterDealer(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMasterDealerMutationResult = NonNullable<Awaited<ReturnType<typeof updateMasterDealer>>>
    export type UpdateMasterDealerMutationBody = BodyType<MasterDealerUpdate>
    export type UpdateMasterDealerMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Update a master dealer
 */
export const useUpdateMasterDealer = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMasterDealer>>, TError,{id: number;data: BodyType<MasterDealerUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMasterDealer>>,
        TError,
        {id: number;data: BodyType<MasterDealerUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMasterDealerMutationOptions(options));
    }

export const getArchiveMasterDealerUrl = (id: number,) => {




  return `/api/master-dealers/${id}`
}

/**
 * @summary Archive (soft-delete) a master dealer
 */
export const archiveMasterDealer = async (id: number, options?: RequestInit): Promise<MasterDealer> => {

  return customFetch<MasterDealer>(getArchiveMasterDealerUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getArchiveMasterDealerMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveMasterDealer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveMasterDealer>>, TError,{id: number}, TContext> => {

const mutationKey = ['archiveMasterDealer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveMasterDealer>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  archiveMasterDealer(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveMasterDealerMutationResult = NonNullable<Awaited<ReturnType<typeof archiveMasterDealer>>>

    export type ArchiveMasterDealerMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Archive (soft-delete) a master dealer
 */
export const useArchiveMasterDealer = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveMasterDealer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveMasterDealer>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getArchiveMasterDealerMutationOptions(options));
    }

export const getRestoreMasterDealerUrl = (id: number,) => {




  return `/api/master-dealers/${id}/restore`
}

/**
 * @summary Restore an archived master dealer
 */
export const restoreMasterDealer = async (id: number, options?: RequestInit): Promise<MasterDealer> => {

  return customFetch<MasterDealer>(getRestoreMasterDealerUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRestoreMasterDealerMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreMasterDealer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreMasterDealer>>, TError,{id: number}, TContext> => {

const mutationKey = ['restoreMasterDealer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreMasterDealer>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  restoreMasterDealer(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreMasterDealerMutationResult = NonNullable<Awaited<ReturnType<typeof restoreMasterDealer>>>

    export type RestoreMasterDealerMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Restore an archived master dealer
 */
export const useRestoreMasterDealer = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreMasterDealer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof restoreMasterDealer>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRestoreMasterDealerMutationOptions(options));
    }

export const getListAccountManagersUrl = (params?: ListAccountManagersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/account-managers?${stringifiedParams}` : `/api/account-managers`
}

/**
 * @summary List account managers
 */
export const listAccountManagers = async (params?: ListAccountManagersParams, options?: RequestInit): Promise<AccountManager[]> => {

  return customFetch<AccountManager[]>(getListAccountManagersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccountManagersQueryKey = (params?: ListAccountManagersParams,) => {
    return [
    `/api/account-managers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAccountManagersQueryOptions = <TData = Awaited<ReturnType<typeof listAccountManagers>>, TError = ErrorType<unknown>>(params?: ListAccountManagersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountManagers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountManagersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountManagers>>> = ({ signal }) => listAccountManagers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccountManagers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountManagersQueryResult = NonNullable<Awaited<ReturnType<typeof listAccountManagers>>>
export type ListAccountManagersQueryError = ErrorType<unknown>


/**
 * @summary List account managers
 */

export function useListAccountManagers<TData = Awaited<ReturnType<typeof listAccountManagers>>, TError = ErrorType<unknown>>(
 params?: ListAccountManagersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountManagers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccountManagersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAccountManagerUrl = () => {




  return `/api/account-managers`
}

/**
 * @summary Create an account manager
 */
export const createAccountManager = async (accountManagerInput: AccountManagerInput, options?: RequestInit): Promise<AccountManager> => {

  return customFetch<AccountManager>(getCreateAccountManagerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountManagerInput,)
  }
);}




export const getCreateAccountManagerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccountManager>>, TError,{data: BodyType<AccountManagerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccountManager>>, TError,{data: BodyType<AccountManagerInput>}, TContext> => {

const mutationKey = ['createAccountManager'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccountManager>>, {data: BodyType<AccountManagerInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAccountManager(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAccountManagerMutationResult = NonNullable<Awaited<ReturnType<typeof createAccountManager>>>
    export type CreateAccountManagerMutationBody = BodyType<AccountManagerInput>
    export type CreateAccountManagerMutationError = ErrorType<unknown>

    /**
 * @summary Create an account manager
 */
export const useCreateAccountManager = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccountManager>>, TError,{data: BodyType<AccountManagerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAccountManager>>,
        TError,
        {data: BodyType<AccountManagerInput>},
        TContext
      > => {
      return useMutation(getCreateAccountManagerMutationOptions(options));
    }

export const getGetAccountManagerUrl = (id: number,) => {




  return `/api/account-managers/${id}`
}

/**
 * @summary Get an account manager
 */
export const getAccountManager = async (id: number, options?: RequestInit): Promise<AccountManager> => {

  return customFetch<AccountManager>(getGetAccountManagerUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountManagerQueryKey = (id: number,) => {
    return [
    `/api/account-managers/${id}`
    ] as const;
    }


export const getGetAccountManagerQueryOptions = <TData = Awaited<ReturnType<typeof getAccountManager>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountManager>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountManagerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountManager>>> = ({ signal }) => getAccountManager(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountManager>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountManagerQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountManager>>>
export type GetAccountManagerQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get an account manager
 */

export function useGetAccountManager<TData = Awaited<ReturnType<typeof getAccountManager>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountManager>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountManagerQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateAccountManagerUrl = (id: number,) => {




  return `/api/account-managers/${id}`
}

/**
 * @summary Update an account manager
 */
export const updateAccountManager = async (id: number,
    accountManagerUpdate: AccountManagerUpdate, options?: RequestInit): Promise<AccountManager> => {

  return customFetch<AccountManager>(getUpdateAccountManagerUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountManagerUpdate,)
  }
);}




export const getUpdateAccountManagerMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountManager>>, TError,{id: number;data: BodyType<AccountManagerUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccountManager>>, TError,{id: number;data: BodyType<AccountManagerUpdate>}, TContext> => {

const mutationKey = ['updateAccountManager'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccountManager>>, {id: number;data: BodyType<AccountManagerUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAccountManager(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountManagerMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccountManager>>>
    export type UpdateAccountManagerMutationBody = BodyType<AccountManagerUpdate>
    export type UpdateAccountManagerMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Update an account manager
 */
export const useUpdateAccountManager = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountManager>>, TError,{id: number;data: BodyType<AccountManagerUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAccountManager>>,
        TError,
        {id: number;data: BodyType<AccountManagerUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAccountManagerMutationOptions(options));
    }

export const getArchiveAccountManagerUrl = (id: number,) => {




  return `/api/account-managers/${id}`
}

/**
 * @summary Archive (soft-delete) an account manager
 */
export const archiveAccountManager = async (id: number, options?: RequestInit): Promise<AccountManager> => {

  return customFetch<AccountManager>(getArchiveAccountManagerUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getArchiveAccountManagerMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAccountManager>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveAccountManager>>, TError,{id: number}, TContext> => {

const mutationKey = ['archiveAccountManager'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveAccountManager>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  archiveAccountManager(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveAccountManagerMutationResult = NonNullable<Awaited<ReturnType<typeof archiveAccountManager>>>

    export type ArchiveAccountManagerMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Archive (soft-delete) an account manager
 */
export const useArchiveAccountManager = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAccountManager>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveAccountManager>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getArchiveAccountManagerMutationOptions(options));
    }

export const getRestoreAccountManagerUrl = (id: number,) => {




  return `/api/account-managers/${id}/restore`
}

/**
 * @summary Restore an archived account manager
 */
export const restoreAccountManager = async (id: number, options?: RequestInit): Promise<AccountManager> => {

  return customFetch<AccountManager>(getRestoreAccountManagerUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRestoreAccountManagerMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreAccountManager>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreAccountManager>>, TError,{id: number}, TContext> => {

const mutationKey = ['restoreAccountManager'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreAccountManager>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  restoreAccountManager(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreAccountManagerMutationResult = NonNullable<Awaited<ReturnType<typeof restoreAccountManager>>>

    export type RestoreAccountManagerMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Restore an archived account manager
 */
export const useRestoreAccountManager = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreAccountManager>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof restoreAccountManager>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRestoreAccountManagerMutationOptions(options));
    }

export const getListAgentsUrl = (params?: ListAgentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/agents?${stringifiedParams}` : `/api/agents`
}

/**
 * @summary List agents
 */
export const listAgents = async (params?: ListAgentsParams, options?: RequestInit): Promise<ListAgents200> => {

  return customFetch<ListAgents200>(getListAgentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAgentsQueryKey = (params?: ListAgentsParams,) => {
    return [
    `/api/agents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAgentsQueryOptions = <TData = Awaited<ReturnType<typeof listAgents>>, TError = ErrorType<unknown>>(params?: ListAgentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgents>>> = ({ signal }) => listAgents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAgentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgents>>>
export type ListAgentsQueryError = ErrorType<unknown>


/**
 * @summary List agents
 */

export function useListAgents<TData = Awaited<ReturnType<typeof listAgents>>, TError = ErrorType<unknown>>(
 params?: ListAgentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAgentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAgentUrl = () => {




  return `/api/agents`
}

/**
 * @summary Create an agent
 */
export const createAgent = async (agentInput: AgentInput, options?: RequestInit): Promise<Agent> => {

  return customFetch<Agent>(getCreateAgentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      agentInput,)
  }
);}




export const getCreateAgentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgent>>, TError,{data: BodyType<AgentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAgent>>, TError,{data: BodyType<AgentInput>}, TContext> => {

const mutationKey = ['createAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAgent>>, {data: BodyType<AgentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAgent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAgentMutationResult = NonNullable<Awaited<ReturnType<typeof createAgent>>>
    export type CreateAgentMutationBody = BodyType<AgentInput>
    export type CreateAgentMutationError = ErrorType<unknown>

    /**
 * @summary Create an agent
 */
export const useCreateAgent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgent>>, TError,{data: BodyType<AgentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAgent>>,
        TError,
        {data: BodyType<AgentInput>},
        TContext
      > => {
      return useMutation(getCreateAgentMutationOptions(options));
    }

export const getGetAgentUrl = (id: number,) => {




  return `/api/agents/${id}`
}

/**
 * @summary Get an agent
 */
export const getAgent = async (id: number, options?: RequestInit): Promise<Agent> => {

  return customFetch<Agent>(getGetAgentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgentQueryKey = (id: number,) => {
    return [
    `/api/agents/${id}`
    ] as const;
    }


export const getGetAgentQueryOptions = <TData = Awaited<ReturnType<typeof getAgent>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgent>>> = ({ signal }) => getAgent(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgentQueryResult = NonNullable<Awaited<ReturnType<typeof getAgent>>>
export type GetAgentQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get an agent
 */

export function useGetAgent<TData = Awaited<ReturnType<typeof getAgent>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateAgentUrl = (id: number,) => {




  return `/api/agents/${id}`
}

/**
 * @summary Update an agent
 */
export const updateAgent = async (id: number,
    agentUpdate: AgentUpdate, options?: RequestInit): Promise<Agent> => {

  return customFetch<Agent>(getUpdateAgentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      agentUpdate,)
  }
);}




export const getUpdateAgentMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgent>>, TError,{id: number;data: BodyType<AgentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAgent>>, TError,{id: number;data: BodyType<AgentUpdate>}, TContext> => {

const mutationKey = ['updateAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAgent>>, {id: number;data: BodyType<AgentUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAgent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAgentMutationResult = NonNullable<Awaited<ReturnType<typeof updateAgent>>>
    export type UpdateAgentMutationBody = BodyType<AgentUpdate>
    export type UpdateAgentMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Update an agent
 */
export const useUpdateAgent = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgent>>, TError,{id: number;data: BodyType<AgentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAgent>>,
        TError,
        {id: number;data: BodyType<AgentUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAgentMutationOptions(options));
    }

export const getSetAgentCommissionPlanUrl = (id: number,) => {




  return `/api/agents/${id}/commission-plan`
}

/**
 * @summary Assign a commission plan to an agent
 */
export const setAgentCommissionPlan = async (id: number,
    agentCommissionPlanUpdate: AgentCommissionPlanUpdate, options?: RequestInit): Promise<Agent> => {

  return customFetch<Agent>(getSetAgentCommissionPlanUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      agentCommissionPlanUpdate,)
  }
);}




export const getSetAgentCommissionPlanMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAgentCommissionPlan>>, TError,{id: number;data: BodyType<AgentCommissionPlanUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAgentCommissionPlan>>, TError,{id: number;data: BodyType<AgentCommissionPlanUpdate>}, TContext> => {

const mutationKey = ['setAgentCommissionPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAgentCommissionPlan>>, {id: number;data: BodyType<AgentCommissionPlanUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  setAgentCommissionPlan(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAgentCommissionPlanMutationResult = NonNullable<Awaited<ReturnType<typeof setAgentCommissionPlan>>>
    export type SetAgentCommissionPlanMutationBody = BodyType<AgentCommissionPlanUpdate>
    export type SetAgentCommissionPlanMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Assign a commission plan to an agent
 */
export const useSetAgentCommissionPlan = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAgentCommissionPlan>>, TError,{id: number;data: BodyType<AgentCommissionPlanUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAgentCommissionPlan>>,
        TError,
        {id: number;data: BodyType<AgentCommissionPlanUpdate>},
        TContext
      > => {
      return useMutation(getSetAgentCommissionPlanMutationOptions(options));
    }

export const getGetAgentComplianceUrl = (id: number,) => {




  return `/api/agents/${id}/compliance`
}

/**
 * @summary KYC and MSA compliance summary for an agent (admin / account manager)
 */
export const getAgentCompliance = async (id: number, options?: RequestInit): Promise<AgentCompliance> => {

  return customFetch<AgentCompliance>(getGetAgentComplianceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgentComplianceQueryKey = (id: number,) => {
    return [
    `/api/agents/${id}/compliance`
    ] as const;
    }


export const getGetAgentComplianceQueryOptions = <TData = Awaited<ReturnType<typeof getAgentCompliance>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentCompliance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentComplianceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentCompliance>>> = ({ signal }) => getAgentCompliance(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentCompliance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgentComplianceQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentCompliance>>>
export type GetAgentComplianceQueryError = ErrorType<NotFoundResponse>


/**
 * @summary KYC and MSA compliance summary for an agent (admin / account manager)
 */

export function useGetAgentCompliance<TData = Awaited<ReturnType<typeof getAgentCompliance>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentCompliance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgentComplianceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAgentTrainingUrl = (id: number,) => {




  return `/api/agents/${id}/training`
}

/**
 * @summary Training / LMS readiness summary for an agent (admin / account manager)
 */
export const getAgentTraining = async (id: number, options?: RequestInit): Promise<AgentTraining> => {

  return customFetch<AgentTraining>(getGetAgentTrainingUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgentTrainingQueryKey = (id: number,) => {
    return [
    `/api/agents/${id}/training`
    ] as const;
    }


export const getGetAgentTrainingQueryOptions = <TData = Awaited<ReturnType<typeof getAgentTraining>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentTraining>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentTrainingQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentTraining>>> = ({ signal }) => getAgentTraining(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentTraining>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgentTrainingQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentTraining>>>
export type GetAgentTrainingQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Training / LMS readiness summary for an agent (admin / account manager)
 */

export function useGetAgentTraining<TData = Awaited<ReturnType<typeof getAgentTraining>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentTraining>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgentTrainingQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAgentNotificationsUrl = (id: number,) => {




  return `/api/agents/${id}/notifications`
}

/**
 * @summary Recent in-app notification history for an agent (admin only)
 */
export const getAgentNotifications = async (id: number, options?: RequestInit): Promise<AgentNotifications> => {

  return customFetch<AgentNotifications>(getGetAgentNotificationsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgentNotificationsQueryKey = (id: number,) => {
    return [
    `/api/agents/${id}/notifications`
    ] as const;
    }


export const getGetAgentNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof getAgentNotifications>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentNotificationsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentNotifications>>> = ({ signal }) => getAgentNotifications(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgentNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentNotifications>>>
export type GetAgentNotificationsQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Recent in-app notification history for an agent (admin only)
 */

export function useGetAgentNotifications<TData = Awaited<ReturnType<typeof getAgentNotifications>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgentNotificationsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListCommissionPlansUrl = () => {




  return `/api/commission-plans`
}

/**
 * @summary List commission plans with their per-package rates
 */
export const listCommissionPlans = async ( options?: RequestInit): Promise<ListCommissionPlans200> => {

  return customFetch<ListCommissionPlans200>(getListCommissionPlansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCommissionPlansQueryKey = () => {
    return [
    `/api/commission-plans`
    ] as const;
    }


export const getListCommissionPlansQueryOptions = <TData = Awaited<ReturnType<typeof listCommissionPlans>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCommissionPlans>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCommissionPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCommissionPlans>>> = ({ signal }) => listCommissionPlans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCommissionPlans>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCommissionPlansQueryResult = NonNullable<Awaited<ReturnType<typeof listCommissionPlans>>>
export type ListCommissionPlansQueryError = ErrorType<unknown>


/**
 * @summary List commission plans with their per-package rates
 */

export function useListCommissionPlans<TData = Awaited<ReturnType<typeof listCommissionPlans>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCommissionPlans>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCommissionPlansQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateCommissionPlanRatesUrl = (id: number,) => {




  return `/api/commission-plans/${id}/rates`
}

/**
 * @summary Create or update the per-package rates for a commission plan
 */
export const updateCommissionPlanRates = async (id: number,
    updateCommissionRatesInput: UpdateCommissionRatesInput, options?: RequestInit): Promise<CommissionPlan> => {

  return customFetch<CommissionPlan>(getUpdateCommissionPlanRatesUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCommissionRatesInput,)
  }
);}




export const getUpdateCommissionPlanRatesMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCommissionPlanRates>>, TError,{id: number;data: BodyType<UpdateCommissionRatesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCommissionPlanRates>>, TError,{id: number;data: BodyType<UpdateCommissionRatesInput>}, TContext> => {

const mutationKey = ['updateCommissionPlanRates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCommissionPlanRates>>, {id: number;data: BodyType<UpdateCommissionRatesInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCommissionPlanRates(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCommissionPlanRatesMutationResult = NonNullable<Awaited<ReturnType<typeof updateCommissionPlanRates>>>
    export type UpdateCommissionPlanRatesMutationBody = BodyType<UpdateCommissionRatesInput>
    export type UpdateCommissionPlanRatesMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Create or update the per-package rates for a commission plan
 */
export const useUpdateCommissionPlanRates = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCommissionPlanRates>>, TError,{id: number;data: BodyType<UpdateCommissionRatesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCommissionPlanRates>>,
        TError,
        {id: number;data: BodyType<UpdateCommissionRatesInput>},
        TContext
      > => {
      return useMutation(getUpdateCommissionPlanRatesMutationOptions(options));
    }

export const getListInvitationsUrl = (params?: ListInvitationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/invitations?${stringifiedParams}` : `/api/invitations`
}

/**
 * @summary List invitations
 */
export const listInvitations = async (params?: ListInvitationsParams, options?: RequestInit): Promise<ListInvitations200> => {

  return customFetch<ListInvitations200>(getListInvitationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvitationsQueryKey = (params?: ListInvitationsParams,) => {
    return [
    `/api/invitations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<unknown>>(params?: ListInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvitationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvitations>>> = ({ signal }) => listInvitations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listInvitations>>>
export type ListInvitationsQueryError = ErrorType<unknown>


/**
 * @summary List invitations
 */

export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<unknown>>(
 params?: ListInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInvitationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateInvitationUrl = () => {




  return `/api/invitations`
}

/**
 * @summary Send an invitation
 */
export const createInvitation = async (invitationInput: InvitationInput, options?: RequestInit): Promise<CreateInvitationResponse> => {

  return customFetch<CreateInvitationResponse>(getCreateInvitationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      invitationInput,)
  }
);}




export const getCreateInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,{data: BodyType<InvitationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,{data: BodyType<InvitationInput>}, TContext> => {

const mutationKey = ['createInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvitation>>, {data: BodyType<InvitationInput>}> = (props) => {
          const {data} = props ?? {};

          return  createInvitation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof createInvitation>>>
    export type CreateInvitationMutationBody = BodyType<InvitationInput>
    export type CreateInvitationMutationError = ErrorType<unknown>

    /**
 * @summary Send an invitation
 */
export const useCreateInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,{data: BodyType<InvitationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInvitation>>,
        TError,
        {data: BodyType<InvitationInput>},
        TContext
      > => {
      return useMutation(getCreateInvitationMutationOptions(options));
    }

export const getGetInvitationUrl = (id: number,) => {




  return `/api/invitations/${id}`
}

/**
 * @summary Get an invitation
 */
export const getInvitation = async (id: number, options?: RequestInit): Promise<Invitation> => {

  return customFetch<Invitation>(getGetInvitationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInvitationQueryKey = (id: number,) => {
    return [
    `/api/invitations/${id}`
    ] as const;
    }


export const getGetInvitationQueryOptions = <TData = Awaited<ReturnType<typeof getInvitation>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitation>>> = ({ signal }) => getInvitation(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvitationQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitation>>>
export type GetInvitationQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get an invitation
 */

export function useGetInvitation<TData = Awaited<ReturnType<typeof getInvitation>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInvitationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateInvitationUrl = (id: number,) => {




  return `/api/invitations/${id}`
}

/**
 * @summary Update an invitation
 */
export const updateInvitation = async (id: number,
    invitationUpdate: InvitationUpdate, options?: RequestInit): Promise<Invitation> => {

  return customFetch<Invitation>(getUpdateInvitationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      invitationUpdate,)
  }
);}




export const getUpdateInvitationMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvitation>>, TError,{id: number;data: BodyType<InvitationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInvitation>>, TError,{id: number;data: BodyType<InvitationUpdate>}, TContext> => {

const mutationKey = ['updateInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInvitation>>, {id: number;data: BodyType<InvitationUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInvitation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof updateInvitation>>>
    export type UpdateInvitationMutationBody = BodyType<InvitationUpdate>
    export type UpdateInvitationMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Update an invitation
 */
export const useUpdateInvitation = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvitation>>, TError,{id: number;data: BodyType<InvitationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInvitation>>,
        TError,
        {id: number;data: BodyType<InvitationUpdate>},
        TContext
      > => {
      return useMutation(getUpdateInvitationMutationOptions(options));
    }

export const getResendInvitationUrl = (id: number,) => {




  return `/api/invitations/${id}/resend`
}

/**
 * @summary Resend an invitation email
 */
export const resendInvitation = async (id: number, options?: RequestInit): Promise<CreateInvitationResponse> => {

  return customFetch<CreateInvitationResponse>(getResendInvitationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResendInvitationMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,{id: number}, TContext> => {

const mutationKey = ['resendInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendInvitation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  resendInvitation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof resendInvitation>>>

    export type ResendInvitationMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Resend an invitation email
 */
export const useResendInvitation = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resendInvitation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getResendInvitationMutationOptions(options));
    }

export const getGetLmsExamUrl = () => {




  return `/api/lms/exam`
}

/**
 * @summary Get the product knowledge exam questions (without answers)
 */
export const getLmsExam = async ( options?: RequestInit): Promise<LmsExam> => {

  return customFetch<LmsExam>(getGetLmsExamUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLmsExamQueryKey = () => {
    return [
    `/api/lms/exam`
    ] as const;
    }


export const getGetLmsExamQueryOptions = <TData = Awaited<ReturnType<typeof getLmsExam>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLmsExam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLmsExamQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLmsExam>>> = ({ signal }) => getLmsExam({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLmsExam>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLmsExamQueryResult = NonNullable<Awaited<ReturnType<typeof getLmsExam>>>
export type GetLmsExamQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Get the product knowledge exam questions (without answers)
 */

export function useGetLmsExam<TData = Awaited<ReturnType<typeof getLmsExam>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLmsExam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLmsExamQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetLmsProgressUrl = () => {




  return `/api/lms/progress`
}

/**
 * @summary Get the current user's training progress
 */
export const getLmsProgress = async ( options?: RequestInit): Promise<LmsProgress> => {

  return customFetch<LmsProgress>(getGetLmsProgressUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLmsProgressQueryKey = () => {
    return [
    `/api/lms/progress`
    ] as const;
    }


export const getGetLmsProgressQueryOptions = <TData = Awaited<ReturnType<typeof getLmsProgress>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLmsProgress>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLmsProgressQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLmsProgress>>> = ({ signal }) => getLmsProgress({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLmsProgress>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLmsProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getLmsProgress>>>
export type GetLmsProgressQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Get the current user's training progress
 */

export function useGetLmsProgress<TData = Awaited<ReturnType<typeof getLmsProgress>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLmsProgress>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLmsProgressQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateLmsProgressUrl = () => {




  return `/api/lms/progress`
}

/**
 * @summary Update the current user's current slide position
 */
export const updateLmsProgress = async (lmsProgressInput: LmsProgressInput, options?: RequestInit): Promise<LmsProgress> => {

  return customFetch<LmsProgress>(getUpdateLmsProgressUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      lmsProgressInput,)
  }
);}




export const getUpdateLmsProgressMutationOptions = <TError = ErrorType<UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLmsProgress>>, TError,{data: BodyType<LmsProgressInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLmsProgress>>, TError,{data: BodyType<LmsProgressInput>}, TContext> => {

const mutationKey = ['updateLmsProgress'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLmsProgress>>, {data: BodyType<LmsProgressInput>}> = (props) => {
          const {data} = props ?? {};

          return  updateLmsProgress(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLmsProgressMutationResult = NonNullable<Awaited<ReturnType<typeof updateLmsProgress>>>
    export type UpdateLmsProgressMutationBody = BodyType<LmsProgressInput>
    export type UpdateLmsProgressMutationError = ErrorType<UnauthorizedResponse>

    /**
 * @summary Update the current user's current slide position
 */
export const useUpdateLmsProgress = <TError = ErrorType<UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLmsProgress>>, TError,{data: BodyType<LmsProgressInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLmsProgress>>,
        TError,
        {data: BodyType<LmsProgressInput>},
        TContext
      > => {
      return useMutation(getUpdateLmsProgressMutationOptions(options));
    }

export const getSubmitLmsAssessmentUrl = () => {




  return `/api/lms/assessment`
}

/**
 * @summary Submit exam answers for server-side scoring
 */
export const submitLmsAssessment = async (lmsAssessmentInput: LmsAssessmentInput, options?: RequestInit): Promise<LmsAssessmentResult> => {

  return customFetch<LmsAssessmentResult>(getSubmitLmsAssessmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      lmsAssessmentInput,)
  }
);}




export const getSubmitLmsAssessmentMutationOptions = <TError = ErrorType<Error | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitLmsAssessment>>, TError,{data: BodyType<LmsAssessmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitLmsAssessment>>, TError,{data: BodyType<LmsAssessmentInput>}, TContext> => {

const mutationKey = ['submitLmsAssessment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitLmsAssessment>>, {data: BodyType<LmsAssessmentInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitLmsAssessment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitLmsAssessmentMutationResult = NonNullable<Awaited<ReturnType<typeof submitLmsAssessment>>>
    export type SubmitLmsAssessmentMutationBody = BodyType<LmsAssessmentInput>
    export type SubmitLmsAssessmentMutationError = ErrorType<Error | UnauthorizedResponse>

    /**
 * @summary Submit exam answers for server-side scoring
 */
export const useSubmitLmsAssessment = <TError = ErrorType<Error | UnauthorizedResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitLmsAssessment>>, TError,{data: BodyType<LmsAssessmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitLmsAssessment>>,
        TError,
        {data: BodyType<LmsAssessmentInput>},
        TContext
      > => {
      return useMutation(getSubmitLmsAssessmentMutationOptions(options));
    }

export const getListApplicationsUrl = (params?: ListApplicationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/applications?${stringifiedParams}` : `/api/applications`
}

/**
 * @summary List onboarding applications
 */
export const listApplications = async (params?: ListApplicationsParams, options?: RequestInit): Promise<ListApplications200> => {

  return customFetch<ListApplications200>(getListApplicationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListApplicationsQueryKey = (params?: ListApplicationsParams,) => {
    return [
    `/api/applications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof listApplications>>, TError = ErrorType<unknown>>(params?: ListApplicationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListApplicationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApplications>>> = ({ signal }) => listApplications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listApplications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof listApplications>>>
export type ListApplicationsQueryError = ErrorType<unknown>


/**
 * @summary List onboarding applications
 */

export function useListApplications<TData = Awaited<ReturnType<typeof listApplications>>, TError = ErrorType<unknown>>(
 params?: ListApplicationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListApplicationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateApplicationUrl = () => {




  return `/api/applications`
}

/**
 * @summary Create an application
 */
export const createApplication = async (applicationInput: ApplicationInput, options?: RequestInit): Promise<Application> => {

  return customFetch<Application>(getCreateApplicationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      applicationInput,)
  }
);}




export const getCreateApplicationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApplication>>, TError,{data: BodyType<ApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createApplication>>, TError,{data: BodyType<ApplicationInput>}, TContext> => {

const mutationKey = ['createApplication'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createApplication>>, {data: BodyType<ApplicationInput>}> = (props) => {
          const {data} = props ?? {};

          return  createApplication(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof createApplication>>>
    export type CreateApplicationMutationBody = BodyType<ApplicationInput>
    export type CreateApplicationMutationError = ErrorType<unknown>

    /**
 * @summary Create an application
 */
export const useCreateApplication = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createApplication>>, TError,{data: BodyType<ApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createApplication>>,
        TError,
        {data: BodyType<ApplicationInput>},
        TContext
      > => {
      return useMutation(getCreateApplicationMutationOptions(options));
    }

export const getGetApplicationUrl = (id: number,) => {




  return `/api/applications/${id}`
}

/**
 * @summary Get an application
 */
export const getApplication = async (id: number, options?: RequestInit): Promise<Application> => {

  return customFetch<Application>(getGetApplicationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApplicationQueryKey = (id: number,) => {
    return [
    `/api/applications/${id}`
    ] as const;
    }


export const getGetApplicationQueryOptions = <TData = Awaited<ReturnType<typeof getApplication>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApplication>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplication>>> = ({ signal }) => getApplication(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApplication>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApplicationQueryResult = NonNullable<Awaited<ReturnType<typeof getApplication>>>
export type GetApplicationQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get an application
 */

export function useGetApplication<TData = Awaited<ReturnType<typeof getApplication>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApplication>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApplicationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateApplicationUrl = (id: number,) => {




  return `/api/applications/${id}`
}

/**
 * @summary Update an application (status decisions)
 */
export const updateApplication = async (id: number,
    applicationUpdate: ApplicationUpdate, options?: RequestInit): Promise<Application> => {

  return customFetch<Application>(getUpdateApplicationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      applicationUpdate,)
  }
);}




export const getUpdateApplicationMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApplication>>, TError,{id: number;data: BodyType<ApplicationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateApplication>>, TError,{id: number;data: BodyType<ApplicationUpdate>}, TContext> => {

const mutationKey = ['updateApplication'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateApplication>>, {id: number;data: BodyType<ApplicationUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateApplication(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof updateApplication>>>
    export type UpdateApplicationMutationBody = BodyType<ApplicationUpdate>
    export type UpdateApplicationMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Update an application (status decisions)
 */
export const useUpdateApplication = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApplication>>, TError,{id: number;data: BodyType<ApplicationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateApplication>>,
        TError,
        {id: number;data: BodyType<ApplicationUpdate>},
        TContext
      > => {
      return useMutation(getUpdateApplicationMutationOptions(options));
    }

export const getListOnboardingReviewsUrl = (params?: ListOnboardingReviewsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/onboarding-reviews?${stringifiedParams}` : `/api/onboarding-reviews`
}

/**
 * @summary List submitted agent onboarding applications for review
 */
export const listOnboardingReviews = async (params?: ListOnboardingReviewsParams, options?: RequestInit): Promise<OnboardingReview[]> => {

  return customFetch<OnboardingReview[]>(getListOnboardingReviewsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOnboardingReviewsQueryKey = (params?: ListOnboardingReviewsParams,) => {
    return [
    `/api/onboarding-reviews`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOnboardingReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listOnboardingReviews>>, TError = ErrorType<unknown>>(params?: ListOnboardingReviewsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOnboardingReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOnboardingReviewsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOnboardingReviews>>> = ({ signal }) => listOnboardingReviews(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOnboardingReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOnboardingReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listOnboardingReviews>>>
export type ListOnboardingReviewsQueryError = ErrorType<unknown>


/**
 * @summary List submitted agent onboarding applications for review
 */

export function useListOnboardingReviews<TData = Awaited<ReturnType<typeof listOnboardingReviews>>, TError = ErrorType<unknown>>(
 params?: ListOnboardingReviewsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOnboardingReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOnboardingReviewsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetOnboardingReviewUrl = (id: number,) => {




  return `/api/onboarding-reviews/${id}`
}

/**
 * @summary Get a single onboarding application
 */
export const getOnboardingReview = async (id: number, options?: RequestInit): Promise<OnboardingReview> => {

  return customFetch<OnboardingReview>(getGetOnboardingReviewUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOnboardingReviewQueryKey = (id: number,) => {
    return [
    `/api/onboarding-reviews/${id}`
    ] as const;
    }


export const getGetOnboardingReviewQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingReview>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOnboardingReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingReviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingReview>>> = ({ signal }) => getOnboardingReview(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingReview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOnboardingReviewQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingReview>>>
export type GetOnboardingReviewQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get a single onboarding application
 */

export function useGetOnboardingReview<TData = Awaited<ReturnType<typeof getOnboardingReview>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOnboardingReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOnboardingReviewQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getReviewOnboardingUrl = (id: number,) => {




  return `/api/onboarding-reviews/${id}`
}

/**
 * @summary Approve, reject, or request changes on an onboarding application
 */
export const reviewOnboarding = async (id: number,
    onboardingReviewUpdate: OnboardingReviewUpdate, options?: RequestInit): Promise<OnboardingReview> => {

  return customFetch<OnboardingReview>(getReviewOnboardingUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      onboardingReviewUpdate,)
  }
);}




export const getReviewOnboardingMutationOptions = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewOnboarding>>, TError,{id: number;data: BodyType<OnboardingReviewUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewOnboarding>>, TError,{id: number;data: BodyType<OnboardingReviewUpdate>}, TContext> => {

const mutationKey = ['reviewOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewOnboarding>>, {id: number;data: BodyType<OnboardingReviewUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  reviewOnboarding(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof reviewOnboarding>>>
    export type ReviewOnboardingMutationBody = BodyType<OnboardingReviewUpdate>
    export type ReviewOnboardingMutationError = ErrorType<Error | NotFoundResponse>

    /**
 * @summary Approve, reject, or request changes on an onboarding application
 */
export const useReviewOnboarding = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewOnboarding>>, TError,{id: number;data: BodyType<OnboardingReviewUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviewOnboarding>>,
        TError,
        {id: number;data: BodyType<OnboardingReviewUpdate>},
        TContext
      > => {
      return useMutation(getReviewOnboardingMutationOptions(options));
    }

export const getSendOnboardingMsaUrl = (id: number,) => {




  return `/api/onboarding-reviews/${id}/msa/send`
}

/**
 * Sends the agent a copy of their Field Sales Agent Agreement. When the agreement is fully executed the signed PDF is attached; otherwise the email links the agent to their portal to read (and sign) it.
 * @summary Email the Field Sales Agent Agreement to the agent
 */
export const sendOnboardingMsa = async (id: number, options?: RequestInit): Promise<MsaSendResult> => {

  return customFetch<MsaSendResult>(getSendOnboardingMsaUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSendOnboardingMsaMutationOptions = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOnboardingMsa>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendOnboardingMsa>>, TError,{id: number}, TContext> => {

const mutationKey = ['sendOnboardingMsa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendOnboardingMsa>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  sendOnboardingMsa(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendOnboardingMsaMutationResult = NonNullable<Awaited<ReturnType<typeof sendOnboardingMsa>>>

    export type SendOnboardingMsaMutationError = ErrorType<Error | NotFoundResponse>

    /**
 * @summary Email the Field Sales Agent Agreement to the agent
 */
export const useSendOnboardingMsa = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOnboardingMsa>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendOnboardingMsa>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getSendOnboardingMsaMutationOptions(options));
    }

export const getGetOnboardingMsaUrl = (id: number,) => {




  return `/api/onboarding-reviews/${id}/msa`
}

/**
 * @summary Get the MSA signature status for an onboarding application
 */
export const getOnboardingMsa = async (id: number, options?: RequestInit): Promise<MsaStatus> => {

  return customFetch<MsaStatus>(getGetOnboardingMsaUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOnboardingMsaQueryKey = (id: number,) => {
    return [
    `/api/onboarding-reviews/${id}/msa`
    ] as const;
    }


export const getGetOnboardingMsaQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingMsa>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOnboardingMsa>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingMsaQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingMsa>>> = ({ signal }) => getOnboardingMsa(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingMsa>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOnboardingMsaQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingMsa>>>
export type GetOnboardingMsaQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get the MSA signature status for an onboarding application
 */

export function useGetOnboardingMsa<TData = Awaited<ReturnType<typeof getOnboardingMsa>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOnboardingMsa>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOnboardingMsaQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCountersignOnboardingMsaUrl = (id: number,) => {




  return `/api/onboarding-reviews/${id}/msa/countersign`
}

/**
 * @summary Admin counter-signs the Field Sales Agent Agreement
 */
export const countersignOnboardingMsa = async (id: number,
    msaSignBody: MsaSignBody, options?: RequestInit): Promise<MsaStatus> => {

  return customFetch<MsaStatus>(getCountersignOnboardingMsaUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      msaSignBody,)
  }
);}




export const getCountersignOnboardingMsaMutationOptions = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof countersignOnboardingMsa>>, TError,{id: number;data: BodyType<MsaSignBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof countersignOnboardingMsa>>, TError,{id: number;data: BodyType<MsaSignBody>}, TContext> => {

const mutationKey = ['countersignOnboardingMsa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof countersignOnboardingMsa>>, {id: number;data: BodyType<MsaSignBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  countersignOnboardingMsa(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CountersignOnboardingMsaMutationResult = NonNullable<Awaited<ReturnType<typeof countersignOnboardingMsa>>>
    export type CountersignOnboardingMsaMutationBody = BodyType<MsaSignBody>
    export type CountersignOnboardingMsaMutationError = ErrorType<Error | NotFoundResponse>

    /**
 * @summary Admin counter-signs the Field Sales Agent Agreement
 */
export const useCountersignOnboardingMsa = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof countersignOnboardingMsa>>, TError,{id: number;data: BodyType<MsaSignBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof countersignOnboardingMsa>>,
        TError,
        {id: number;data: BodyType<MsaSignBody>},
        TContext
      > => {
      return useMutation(getCountersignOnboardingMsaMutationOptions(options));
    }

export const getListOrdersUrl = (params?: ListOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/orders?${stringifiedParams}` : `/api/orders`
}

/**
 * @summary List leads and orders
 */
export const listOrders = async (params?: ListOrdersParams, options?: RequestInit): Promise<ListOrders200> => {

  return customFetch<ListOrders200>(getListOrdersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrdersQueryKey = (params?: ListOrdersParams,) => {
    return [
    `/api/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrdersQueryOptions = <TData = Awaited<ReturnType<typeof listOrders>>, TError = ErrorType<unknown>>(params?: ListOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrders>>> = ({ signal }) => listOrders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof listOrders>>>
export type ListOrdersQueryError = ErrorType<unknown>


/**
 * @summary List leads and orders
 */

export function useListOrders<TData = Awaited<ReturnType<typeof listOrders>>, TError = ErrorType<unknown>>(
 params?: ListOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOrders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateOrderUrl = () => {




  return `/api/orders`
}

/**
 * @summary Submit a new lead/order
 */
export const createOrder = async (orderInput: OrderInput, options?: RequestInit): Promise<Order> => {

  return customFetch<Order>(getCreateOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      orderInput,)
  }
);}




export const getCreateOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrder>>, TError,{data: BodyType<OrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrder>>, TError,{data: BodyType<OrderInput>}, TContext> => {

const mutationKey = ['createOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrder>>, {data: BodyType<OrderInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createOrder>>>
    export type CreateOrderMutationBody = BodyType<OrderInput>
    export type CreateOrderMutationError = ErrorType<unknown>

    /**
 * @summary Submit a new lead/order
 */
export const useCreateOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrder>>, TError,{data: BodyType<OrderInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrder>>,
        TError,
        {data: BodyType<OrderInput>},
        TContext
      > => {
      return useMutation(getCreateOrderMutationOptions(options));
    }

export const getGetOrderUrl = (id: number,) => {




  return `/api/orders/${id}`
}

/**
 * @summary Get an order
 */
export const getOrder = async (id: number, options?: RequestInit): Promise<Order> => {

  return customFetch<Order>(getGetOrderUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderQueryKey = (id: number,) => {
    return [
    `/api/orders/${id}`
    ] as const;
    }


export const getGetOrderQueryOptions = <TData = Awaited<ReturnType<typeof getOrder>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrder>>> = ({ signal }) => getOrder(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getOrder>>>
export type GetOrderQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get an order
 */

export function useGetOrder<TData = Awaited<ReturnType<typeof getOrder>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateOrderUrl = (id: number,) => {




  return `/api/orders/${id}`
}

/**
 * @summary Update an order
 */
export const updateOrder = async (id: number,
    orderUpdate: OrderUpdate, options?: RequestInit): Promise<Order> => {

  return customFetch<Order>(getUpdateOrderUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      orderUpdate,)
  }
);}




export const getUpdateOrderMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrder>>, TError,{id: number;data: BodyType<OrderUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrder>>, TError,{id: number;data: BodyType<OrderUpdate>}, TContext> => {

const mutationKey = ['updateOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrder>>, {id: number;data: BodyType<OrderUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrderMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrder>>>
    export type UpdateOrderMutationBody = BodyType<OrderUpdate>
    export type UpdateOrderMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Update an order
 */
export const useUpdateOrder = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrder>>, TError,{id: number;data: BodyType<OrderUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOrder>>,
        TError,
        {id: number;data: BodyType<OrderUpdate>},
        TContext
      > => {
      return useMutation(getUpdateOrderMutationOptions(options));
    }

export const getGetMyWalletUrl = () => {




  return `/api/wallet`
}

/**
 * @summary Get the current agent's wallet summary
 */
export const getMyWallet = async ( options?: RequestInit): Promise<Wallet> => {

  return customFetch<Wallet>(getGetMyWalletUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyWalletQueryKey = () => {
    return [
    `/api/wallet`
    ] as const;
    }


export const getGetMyWalletQueryOptions = <TData = Awaited<ReturnType<typeof getMyWallet>>, TError = ErrorType<UnauthorizedResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyWallet>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyWalletQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyWallet>>> = ({ signal }) => getMyWallet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyWallet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyWalletQueryResult = NonNullable<Awaited<ReturnType<typeof getMyWallet>>>
export type GetMyWalletQueryError = ErrorType<UnauthorizedResponse>


/**
 * @summary Get the current agent's wallet summary
 */

export function useGetMyWallet<TData = Awaited<ReturnType<typeof getMyWallet>>, TError = ErrorType<UnauthorizedResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyWallet>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyWalletQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListTransactionsUrl = (params?: ListTransactionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/transactions?${stringifiedParams}` : `/api/transactions`
}

/**
 * @summary List wallet transactions
 */
export const listTransactions = async (params?: ListTransactionsParams, options?: RequestInit): Promise<ListTransactions200> => {

  return customFetch<ListTransactions200>(getListTransactionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTransactionsQueryKey = (params?: ListTransactionsParams,) => {
    return [
    `/api/transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof listTransactions>>, TError = ErrorType<unknown>>(params?: ListTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTransactions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTransactionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTransactions>>> = ({ signal }) => listTransactions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTransactions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof listTransactions>>>
export type ListTransactionsQueryError = ErrorType<unknown>


/**
 * @summary List wallet transactions
 */

export function useListTransactions<TData = Awaited<ReturnType<typeof listTransactions>>, TError = ErrorType<unknown>>(
 params?: ListTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTransactions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTransactionUrl = () => {




  return `/api/transactions`
}

/**
 * @summary Create a transaction
 */
export const createTransaction = async (transactionInput: TransactionInput, options?: RequestInit): Promise<Transaction> => {

  return customFetch<Transaction>(getCreateTransactionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      transactionInput,)
  }
);}




export const getCreateTransactionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTransaction>>, TError,{data: BodyType<TransactionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTransaction>>, TError,{data: BodyType<TransactionInput>}, TContext> => {

const mutationKey = ['createTransaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTransaction>>, {data: BodyType<TransactionInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTransaction(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof createTransaction>>>
    export type CreateTransactionMutationBody = BodyType<TransactionInput>
    export type CreateTransactionMutationError = ErrorType<unknown>

    /**
 * @summary Create a transaction
 */
export const useCreateTransaction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTransaction>>, TError,{data: BodyType<TransactionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTransaction>>,
        TError,
        {data: BodyType<TransactionInput>},
        TContext
      > => {
      return useMutation(getCreateTransactionMutationOptions(options));
    }

export const getListPaymentRunsUrl = () => {




  return `/api/payment-runs`
}

/**
 * @summary List payment runs
 */
export const listPaymentRuns = async ( options?: RequestInit): Promise<PaymentRun[]> => {

  return customFetch<PaymentRun[]>(getListPaymentRunsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPaymentRunsQueryKey = () => {
    return [
    `/api/payment-runs`
    ] as const;
    }


export const getListPaymentRunsQueryOptions = <TData = Awaited<ReturnType<typeof listPaymentRuns>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPaymentRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPaymentRunsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPaymentRuns>>> = ({ signal }) => listPaymentRuns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPaymentRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPaymentRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listPaymentRuns>>>
export type ListPaymentRunsQueryError = ErrorType<unknown>


/**
 * @summary List payment runs
 */

export function useListPaymentRuns<TData = Awaited<ReturnType<typeof listPaymentRuns>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPaymentRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPaymentRunsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreatePaymentRunUrl = () => {




  return `/api/payment-runs`
}

/**
 * @summary Create a payment run
 */
export const createPaymentRun = async (paymentRunInput: PaymentRunInput, options?: RequestInit): Promise<PaymentRun> => {

  return customFetch<PaymentRun>(getCreatePaymentRunUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      paymentRunInput,)
  }
);}




export const getCreatePaymentRunMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentRun>>, TError,{data: BodyType<PaymentRunInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPaymentRun>>, TError,{data: BodyType<PaymentRunInput>}, TContext> => {

const mutationKey = ['createPaymentRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPaymentRun>>, {data: BodyType<PaymentRunInput>}> = (props) => {
          const {data} = props ?? {};

          return  createPaymentRun(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePaymentRunMutationResult = NonNullable<Awaited<ReturnType<typeof createPaymentRun>>>
    export type CreatePaymentRunMutationBody = BodyType<PaymentRunInput>
    export type CreatePaymentRunMutationError = ErrorType<unknown>

    /**
 * @summary Create a payment run
 */
export const useCreatePaymentRun = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentRun>>, TError,{data: BodyType<PaymentRunInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPaymentRun>>,
        TError,
        {data: BodyType<PaymentRunInput>},
        TContext
      > => {
      return useMutation(getCreatePaymentRunMutationOptions(options));
    }

export const getGetPaymentRunUrl = (id: number,) => {




  return `/api/payment-runs/${id}`
}

/**
 * @summary Get a payment run with its items
 */
export const getPaymentRun = async (id: number, options?: RequestInit): Promise<PaymentRunDetail> => {

  return customFetch<PaymentRunDetail>(getGetPaymentRunUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPaymentRunQueryKey = (id: number,) => {
    return [
    `/api/payment-runs/${id}`
    ] as const;
    }


export const getGetPaymentRunQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentRun>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentRun>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentRunQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentRun>>> = ({ signal }) => getPaymentRun(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentRun>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPaymentRunQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentRun>>>
export type GetPaymentRunQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get a payment run with its items
 */

export function useGetPaymentRun<TData = Awaited<ReturnType<typeof getPaymentRun>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentRun>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPaymentRunQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdatePaymentRunUrl = (id: number,) => {




  return `/api/payment-runs/${id}`
}

/**
 * @summary Update a payment run status
 */
export const updatePaymentRun = async (id: number,
    paymentRunUpdate: PaymentRunUpdate, options?: RequestInit): Promise<PaymentRun> => {

  return customFetch<PaymentRun>(getUpdatePaymentRunUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      paymentRunUpdate,)
  }
);}




export const getUpdatePaymentRunMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentRun>>, TError,{id: number;data: BodyType<PaymentRunUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePaymentRun>>, TError,{id: number;data: BodyType<PaymentRunUpdate>}, TContext> => {

const mutationKey = ['updatePaymentRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePaymentRun>>, {id: number;data: BodyType<PaymentRunUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePaymentRun(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePaymentRunMutationResult = NonNullable<Awaited<ReturnType<typeof updatePaymentRun>>>
    export type UpdatePaymentRunMutationBody = BodyType<PaymentRunUpdate>
    export type UpdatePaymentRunMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Update a payment run status
 */
export const useUpdatePaymentRun = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentRun>>, TError,{id: number;data: BodyType<PaymentRunUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePaymentRun>>,
        TError,
        {id: number;data: BodyType<PaymentRunUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePaymentRunMutationOptions(options));
    }

export const getExportPaymentRunEftUrl = (id: number,) => {




  return `/api/payment-runs/${id}/export`
}

/**
 * Builds a bank-ingestable EFT batch CSV from the payment run's item
snapshots (account holder, bank, branch code, account number, amount in
rand, and a per-line reference). Items without banking details are held
and excluded. Moves the run to "processing" and stamps exportedAt. The
response carries full account numbers and is finance/admin only.

 * @summary Generate the bank EFT batch CSV for a payment run
 */
export const exportPaymentRunEft = async (id: number, options?: RequestInit): Promise<EftExportResult> => {

  return customFetch<EftExportResult>(getExportPaymentRunEftUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getExportPaymentRunEftMutationOptions = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportPaymentRunEft>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof exportPaymentRunEft>>, TError,{id: number}, TContext> => {

const mutationKey = ['exportPaymentRunEft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportPaymentRunEft>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  exportPaymentRunEft(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExportPaymentRunEftMutationResult = NonNullable<Awaited<ReturnType<typeof exportPaymentRunEft>>>

    export type ExportPaymentRunEftMutationError = ErrorType<Error | NotFoundResponse>

    /**
 * @summary Generate the bank EFT batch CSV for a payment run
 */
export const useExportPaymentRunEft = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportPaymentRunEft>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportPaymentRunEft>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getExportPaymentRunEftMutationOptions(options));
    }

export const getCancelPaymentRunUrl = (id: number,) => {




  return `/api/payment-runs/${id}/cancel`
}

/**
 * Marks a draft or processing run as "cancelled" and releases any
transactions it had reserved back to pending so they can be settled by a
future run. Already-paid items are left untouched. Terminal runs
(completed/failed/cancelled) cannot be cancelled.

 * @summary Cancel a payment run
 */
export const cancelPaymentRun = async (id: number, options?: RequestInit): Promise<PaymentRun> => {

  return customFetch<PaymentRun>(getCancelPaymentRunUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCancelPaymentRunMutationOptions = <TError = ErrorType<NotFoundResponse | Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPaymentRun>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelPaymentRun>>, TError,{id: number}, TContext> => {

const mutationKey = ['cancelPaymentRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelPaymentRun>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  cancelPaymentRun(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelPaymentRunMutationResult = NonNullable<Awaited<ReturnType<typeof cancelPaymentRun>>>

    export type CancelPaymentRunMutationError = ErrorType<NotFoundResponse | Error>

    /**
 * @summary Cancel a payment run
 */
export const useCancelPaymentRun = <TError = ErrorType<NotFoundResponse | Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPaymentRun>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelPaymentRun>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCancelPaymentRunMutationOptions(options));
    }

export const getFailPaymentRunUrl = (id: number,) => {




  return `/api/payment-runs/${id}/fail`
}

/**
 * Marks a draft or processing run as "failed" (e.g. the bank rejected the
whole batch) and releases any transactions it had reserved back to
pending for a future run. Already-paid items are left untouched. Terminal
runs cannot be failed.

 * @summary Mark a payment run as failed
 */
export const failPaymentRun = async (id: number,
    failPaymentRunInput?: FailPaymentRunInput, options?: RequestInit): Promise<PaymentRun> => {

  return customFetch<PaymentRun>(getFailPaymentRunUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      failPaymentRunInput,)
  }
);}




export const getFailPaymentRunMutationOptions = <TError = ErrorType<NotFoundResponse | Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof failPaymentRun>>, TError,{id: number;data?: BodyType<FailPaymentRunInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof failPaymentRun>>, TError,{id: number;data?: BodyType<FailPaymentRunInput>}, TContext> => {

const mutationKey = ['failPaymentRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof failPaymentRun>>, {id: number;data?: BodyType<FailPaymentRunInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  failPaymentRun(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FailPaymentRunMutationResult = NonNullable<Awaited<ReturnType<typeof failPaymentRun>>>
    export type FailPaymentRunMutationBody = BodyType<FailPaymentRunInput> | undefined
    export type FailPaymentRunMutationError = ErrorType<NotFoundResponse | Error>

    /**
 * @summary Mark a payment run as failed
 */
export const useFailPaymentRun = <TError = ErrorType<NotFoundResponse | Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof failPaymentRun>>, TError,{id: number;data?: BodyType<FailPaymentRunInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof failPaymentRun>>,
        TError,
        {id: number;data?: BodyType<FailPaymentRunInput>},
        TContext
      > => {
      return useMutation(getFailPaymentRunMutationOptions(options));
    }

export const getReconcilePaymentRunUrl = (id: number,) => {




  return `/api/payment-runs/${id}/reconcile`
}

/**
 * Downloads a previously uploaded bank result/settlement report from
object storage, parses it (CSV or XLSX), matches each row to a run item
by per-line reference (fallback account number), and marks each item
paid or failed. Paid items settle their linked transactions and
decrement the agent wallet; failed items return their transactions to
pending for a future run. Allowed only while the run is "processing".

 * @summary Reconcile a bank result report against a payment run
 */
export const reconcilePaymentRun = async (id: number,
    reconcilePaymentRunInput: ReconcilePaymentRunInput, options?: RequestInit): Promise<ReconcilePaymentRunResult> => {

  return customFetch<ReconcilePaymentRunResult>(getReconcilePaymentRunUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reconcilePaymentRunInput,)
  }
);}




export const getReconcilePaymentRunMutationOptions = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcilePaymentRun>>, TError,{id: number;data: BodyType<ReconcilePaymentRunInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reconcilePaymentRun>>, TError,{id: number;data: BodyType<ReconcilePaymentRunInput>}, TContext> => {

const mutationKey = ['reconcilePaymentRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reconcilePaymentRun>>, {id: number;data: BodyType<ReconcilePaymentRunInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  reconcilePaymentRun(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReconcilePaymentRunMutationResult = NonNullable<Awaited<ReturnType<typeof reconcilePaymentRun>>>
    export type ReconcilePaymentRunMutationBody = BodyType<ReconcilePaymentRunInput>
    export type ReconcilePaymentRunMutationError = ErrorType<Error | NotFoundResponse>

    /**
 * @summary Reconcile a bank result report against a payment run
 */
export const useReconcilePaymentRun = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcilePaymentRun>>, TError,{id: number;data: BodyType<ReconcilePaymentRunInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reconcilePaymentRun>>,
        TError,
        {id: number;data: BodyType<ReconcilePaymentRunInput>},
        TContext
      > => {
      return useMutation(getReconcilePaymentRunMutationOptions(options));
    }

export const getListBankChangeRequestsUrl = (params?: ListBankChangeRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bank-change-requests?${stringifiedParams}` : `/api/bank-change-requests`
}

/**
 * @summary List bank change requests
 */
export const listBankChangeRequests = async (params?: ListBankChangeRequestsParams, options?: RequestInit): Promise<BankChangeRequest[]> => {

  return customFetch<BankChangeRequest[]>(getListBankChangeRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBankChangeRequestsQueryKey = (params?: ListBankChangeRequestsParams,) => {
    return [
    `/api/bank-change-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBankChangeRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listBankChangeRequests>>, TError = ErrorType<unknown>>(params?: ListBankChangeRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankChangeRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBankChangeRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBankChangeRequests>>> = ({ signal }) => listBankChangeRequests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBankChangeRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListBankChangeRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listBankChangeRequests>>>
export type ListBankChangeRequestsQueryError = ErrorType<unknown>


/**
 * @summary List bank change requests
 */

export function useListBankChangeRequests<TData = Awaited<ReturnType<typeof listBankChangeRequests>>, TError = ErrorType<unknown>>(
 params?: ListBankChangeRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listBankChangeRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListBankChangeRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBankChangeRequestUrl = () => {




  return `/api/bank-change-requests`
}

/**
 * @summary Submit a bank change request
 */
export const createBankChangeRequest = async (bankChangeRequestInput: BankChangeRequestInput, options?: RequestInit): Promise<BankChangeRequest> => {

  return customFetch<BankChangeRequest>(getCreateBankChangeRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bankChangeRequestInput,)
  }
);}




export const getCreateBankChangeRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBankChangeRequest>>, TError,{data: BodyType<BankChangeRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBankChangeRequest>>, TError,{data: BodyType<BankChangeRequestInput>}, TContext> => {

const mutationKey = ['createBankChangeRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBankChangeRequest>>, {data: BodyType<BankChangeRequestInput>}> = (props) => {
          const {data} = props ?? {};

          return  createBankChangeRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBankChangeRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createBankChangeRequest>>>
    export type CreateBankChangeRequestMutationBody = BodyType<BankChangeRequestInput>
    export type CreateBankChangeRequestMutationError = ErrorType<unknown>

    /**
 * @summary Submit a bank change request
 */
export const useCreateBankChangeRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBankChangeRequest>>, TError,{data: BodyType<BankChangeRequestInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBankChangeRequest>>,
        TError,
        {data: BodyType<BankChangeRequestInput>},
        TContext
      > => {
      return useMutation(getCreateBankChangeRequestMutationOptions(options));
    }

export const getGetBankChangeRequestUrl = (id: number,) => {




  return `/api/bank-change-requests/${id}`
}

/**
 * @summary Get a bank change request
 */
export const getBankChangeRequest = async (id: number, options?: RequestInit): Promise<BankChangeRequest> => {

  return customFetch<BankChangeRequest>(getGetBankChangeRequestUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBankChangeRequestQueryKey = (id: number,) => {
    return [
    `/api/bank-change-requests/${id}`
    ] as const;
    }


export const getGetBankChangeRequestQueryOptions = <TData = Awaited<ReturnType<typeof getBankChangeRequest>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankChangeRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankChangeRequestQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankChangeRequest>>> = ({ signal }) => getBankChangeRequest(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankChangeRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBankChangeRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getBankChangeRequest>>>
export type GetBankChangeRequestQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get a bank change request
 */

export function useGetBankChangeRequest<TData = Awaited<ReturnType<typeof getBankChangeRequest>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBankChangeRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBankChangeRequestQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateBankChangeRequestUrl = (id: number,) => {




  return `/api/bank-change-requests/${id}`
}

/**
 * @summary Update / verify a bank change request
 */
export const updateBankChangeRequest = async (id: number,
    bankChangeRequestUpdate: BankChangeRequestUpdate, options?: RequestInit): Promise<BankChangeRequest> => {

  return customFetch<BankChangeRequest>(getUpdateBankChangeRequestUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bankChangeRequestUpdate,)
  }
);}




export const getUpdateBankChangeRequestMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBankChangeRequest>>, TError,{id: number;data: BodyType<BankChangeRequestUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBankChangeRequest>>, TError,{id: number;data: BodyType<BankChangeRequestUpdate>}, TContext> => {

const mutationKey = ['updateBankChangeRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBankChangeRequest>>, {id: number;data: BodyType<BankChangeRequestUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBankChangeRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBankChangeRequestMutationResult = NonNullable<Awaited<ReturnType<typeof updateBankChangeRequest>>>
    export type UpdateBankChangeRequestMutationBody = BodyType<BankChangeRequestUpdate>
    export type UpdateBankChangeRequestMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Update / verify a bank change request
 */
export const useUpdateBankChangeRequest = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBankChangeRequest>>, TError,{id: number;data: BodyType<BankChangeRequestUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateBankChangeRequest>>,
        TError,
        {id: number;data: BodyType<BankChangeRequestUpdate>},
        TContext
      > => {
      return useMutation(getUpdateBankChangeRequestMutationOptions(options));
    }

export const getRequestBankChangeVerificationUrl = () => {




  return `/api/bank-change-verifications`
}

/**
 * @summary Start a dual-channel (SMS + email) OTP session for a bank change
 */
export const requestBankChangeVerification = async ( options?: RequestInit): Promise<BankChangeVerificationStatus> => {

  return customFetch<BankChangeVerificationStatus>(getRequestBankChangeVerificationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRequestBankChangeVerificationMutationOptions = <TError = ErrorType<Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestBankChangeVerification>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestBankChangeVerification>>, TError,void, TContext> => {

const mutationKey = ['requestBankChangeVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestBankChangeVerification>>, void> = () => {


          return  requestBankChangeVerification(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestBankChangeVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof requestBankChangeVerification>>>

    export type RequestBankChangeVerificationMutationError = ErrorType<Error>

    /**
 * @summary Start a dual-channel (SMS + email) OTP session for a bank change
 */
export const useRequestBankChangeVerification = <TError = ErrorType<Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestBankChangeVerification>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestBankChangeVerification>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRequestBankChangeVerificationMutationOptions(options));
    }

export const getVerifyBankChangeVerificationUrl = (id: number,) => {




  return `/api/bank-change-verifications/${id}/verify`
}

/**
 * @summary Verify one channel's OTP code for a bank-change session
 */
export const verifyBankChangeVerification = async (id: number,
    bankChangeVerifyBody: BankChangeVerifyBody, options?: RequestInit): Promise<BankChangeVerificationStatus> => {

  return customFetch<BankChangeVerificationStatus>(getVerifyBankChangeVerificationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bankChangeVerifyBody,)
  }
);}




export const getVerifyBankChangeVerificationMutationOptions = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyBankChangeVerification>>, TError,{id: number;data: BodyType<BankChangeVerifyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyBankChangeVerification>>, TError,{id: number;data: BodyType<BankChangeVerifyBody>}, TContext> => {

const mutationKey = ['verifyBankChangeVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyBankChangeVerification>>, {id: number;data: BodyType<BankChangeVerifyBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  verifyBankChangeVerification(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyBankChangeVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof verifyBankChangeVerification>>>
    export type VerifyBankChangeVerificationMutationBody = BodyType<BankChangeVerifyBody>
    export type VerifyBankChangeVerificationMutationError = ErrorType<Error | NotFoundResponse>

    /**
 * @summary Verify one channel's OTP code for a bank-change session
 */
export const useVerifyBankChangeVerification = <TError = ErrorType<Error | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyBankChangeVerification>>, TError,{id: number;data: BodyType<BankChangeVerifyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyBankChangeVerification>>,
        TError,
        {id: number;data: BodyType<BankChangeVerifyBody>},
        TContext
      > => {
      return useMutation(getVerifyBankChangeVerificationMutationOptions(options));
    }

export const getListDisputesUrl = (params?: ListDisputesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/disputes?${stringifiedParams}` : `/api/disputes`
}

/**
 * @summary List disputes
 */
export const listDisputes = async (params?: ListDisputesParams, options?: RequestInit): Promise<ListDisputes200> => {

  return customFetch<ListDisputes200>(getListDisputesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDisputesQueryKey = (params?: ListDisputesParams,) => {
    return [
    `/api/disputes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDisputesQueryOptions = <TData = Awaited<ReturnType<typeof listDisputes>>, TError = ErrorType<unknown>>(params?: ListDisputesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDisputes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDisputesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDisputes>>> = ({ signal }) => listDisputes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDisputes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDisputesQueryResult = NonNullable<Awaited<ReturnType<typeof listDisputes>>>
export type ListDisputesQueryError = ErrorType<unknown>


/**
 * @summary List disputes
 */

export function useListDisputes<TData = Awaited<ReturnType<typeof listDisputes>>, TError = ErrorType<unknown>>(
 params?: ListDisputesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDisputes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDisputesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateDisputeUrl = () => {




  return `/api/disputes`
}

/**
 * @summary Raise a dispute
 */
export const createDispute = async (disputeInput: DisputeInput, options?: RequestInit): Promise<Dispute> => {

  return customFetch<Dispute>(getCreateDisputeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      disputeInput,)
  }
);}




export const getCreateDisputeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDispute>>, TError,{data: BodyType<DisputeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDispute>>, TError,{data: BodyType<DisputeInput>}, TContext> => {

const mutationKey = ['createDispute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDispute>>, {data: BodyType<DisputeInput>}> = (props) => {
          const {data} = props ?? {};

          return  createDispute(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDisputeMutationResult = NonNullable<Awaited<ReturnType<typeof createDispute>>>
    export type CreateDisputeMutationBody = BodyType<DisputeInput>
    export type CreateDisputeMutationError = ErrorType<unknown>

    /**
 * @summary Raise a dispute
 */
export const useCreateDispute = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDispute>>, TError,{data: BodyType<DisputeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDispute>>,
        TError,
        {data: BodyType<DisputeInput>},
        TContext
      > => {
      return useMutation(getCreateDisputeMutationOptions(options));
    }

export const getGetDisputeUrl = (id: number,) => {




  return `/api/disputes/${id}`
}

/**
 * @summary Get a dispute
 */
export const getDispute = async (id: number, options?: RequestInit): Promise<Dispute> => {

  return customFetch<Dispute>(getGetDisputeUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDisputeQueryKey = (id: number,) => {
    return [
    `/api/disputes/${id}`
    ] as const;
    }


export const getGetDisputeQueryOptions = <TData = Awaited<ReturnType<typeof getDispute>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDispute>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDisputeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDispute>>> = ({ signal }) => getDispute(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDispute>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDisputeQueryResult = NonNullable<Awaited<ReturnType<typeof getDispute>>>
export type GetDisputeQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get a dispute
 */

export function useGetDispute<TData = Awaited<ReturnType<typeof getDispute>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDispute>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDisputeQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateDisputeUrl = (id: number,) => {




  return `/api/disputes/${id}`
}

/**
 * @summary Update a dispute
 */
export const updateDispute = async (id: number,
    disputeUpdate: DisputeUpdate, options?: RequestInit): Promise<Dispute> => {

  return customFetch<Dispute>(getUpdateDisputeUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      disputeUpdate,)
  }
);}




export const getUpdateDisputeMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDispute>>, TError,{id: number;data: BodyType<DisputeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDispute>>, TError,{id: number;data: BodyType<DisputeUpdate>}, TContext> => {

const mutationKey = ['updateDispute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDispute>>, {id: number;data: BodyType<DisputeUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDispute(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDisputeMutationResult = NonNullable<Awaited<ReturnType<typeof updateDispute>>>
    export type UpdateDisputeMutationBody = BodyType<DisputeUpdate>
    export type UpdateDisputeMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Update a dispute
 */
export const useUpdateDispute = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDispute>>, TError,{id: number;data: BodyType<DisputeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDispute>>,
        TError,
        {id: number;data: BodyType<DisputeUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDisputeMutationOptions(options));
    }

export const getListTicketsUrl = (params?: ListTicketsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tickets?${stringifiedParams}` : `/api/tickets`
}

/**
 * @summary List support tickets
 */
export const listTickets = async (params?: ListTicketsParams, options?: RequestInit): Promise<ListTickets200> => {

  return customFetch<ListTickets200>(getListTicketsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTicketsQueryKey = (params?: ListTicketsParams,) => {
    return [
    `/api/tickets`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTicketsQueryOptions = <TData = Awaited<ReturnType<typeof listTickets>>, TError = ErrorType<unknown>>(params?: ListTicketsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTickets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTicketsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTickets>>> = ({ signal }) => listTickets(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTickets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTicketsQueryResult = NonNullable<Awaited<ReturnType<typeof listTickets>>>
export type ListTicketsQueryError = ErrorType<unknown>


/**
 * @summary List support tickets
 */

export function useListTickets<TData = Awaited<ReturnType<typeof listTickets>>, TError = ErrorType<unknown>>(
 params?: ListTicketsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTickets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTicketsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTicketUrl = () => {




  return `/api/tickets`
}

/**
 * @summary Raise a support ticket
 */
export const createTicket = async (ticketInput: TicketInput, options?: RequestInit): Promise<Ticket> => {

  return customFetch<Ticket>(getCreateTicketUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketInput,)
  }
);}




export const getCreateTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTicket>>, TError,{data: BodyType<TicketInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTicket>>, TError,{data: BodyType<TicketInput>}, TContext> => {

const mutationKey = ['createTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTicket>>, {data: BodyType<TicketInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTicket(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTicketMutationResult = NonNullable<Awaited<ReturnType<typeof createTicket>>>
    export type CreateTicketMutationBody = BodyType<TicketInput>
    export type CreateTicketMutationError = ErrorType<unknown>

    /**
 * @summary Raise a support ticket
 */
export const useCreateTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTicket>>, TError,{data: BodyType<TicketInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTicket>>,
        TError,
        {data: BodyType<TicketInput>},
        TContext
      > => {
      return useMutation(getCreateTicketMutationOptions(options));
    }

export const getListTicketAssigneesUrl = () => {




  return `/api/tickets/assignees`
}

/**
 * @summary List staff a ticket can be assigned to
 */
export const listTicketAssignees = async ( options?: RequestInit): Promise<TicketAssignee[]> => {

  return customFetch<TicketAssignee[]>(getListTicketAssigneesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTicketAssigneesQueryKey = () => {
    return [
    `/api/tickets/assignees`
    ] as const;
    }


export const getListTicketAssigneesQueryOptions = <TData = Awaited<ReturnType<typeof listTicketAssignees>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTicketAssignees>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTicketAssigneesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTicketAssignees>>> = ({ signal }) => listTicketAssignees({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTicketAssignees>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTicketAssigneesQueryResult = NonNullable<Awaited<ReturnType<typeof listTicketAssignees>>>
export type ListTicketAssigneesQueryError = ErrorType<unknown>


/**
 * @summary List staff a ticket can be assigned to
 */

export function useListTicketAssignees<TData = Awaited<ReturnType<typeof listTicketAssignees>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTicketAssignees>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTicketAssigneesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetTicketUrl = (id: number,) => {




  return `/api/tickets/${id}`
}

/**
 * @summary Get a ticket with its messages
 */
export const getTicket = async (id: number, options?: RequestInit): Promise<TicketDetail> => {

  return customFetch<TicketDetail>(getGetTicketUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTicketQueryKey = (id: number,) => {
    return [
    `/api/tickets/${id}`
    ] as const;
    }


export const getGetTicketQueryOptions = <TData = Awaited<ReturnType<typeof getTicket>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTicket>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTicketQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTicket>>> = ({ signal }) => getTicket(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTicket>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTicketQueryResult = NonNullable<Awaited<ReturnType<typeof getTicket>>>
export type GetTicketQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get a ticket with its messages
 */

export function useGetTicket<TData = Awaited<ReturnType<typeof getTicket>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTicket>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTicketQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateTicketUrl = (id: number,) => {




  return `/api/tickets/${id}`
}

/**
 * @summary Update a ticket
 */
export const updateTicket = async (id: number,
    ticketUpdate: TicketUpdate, options?: RequestInit): Promise<Ticket> => {

  return customFetch<Ticket>(getUpdateTicketUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketUpdate,)
  }
);}




export const getUpdateTicketMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTicket>>, TError,{id: number;data: BodyType<TicketUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTicket>>, TError,{id: number;data: BodyType<TicketUpdate>}, TContext> => {

const mutationKey = ['updateTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTicket>>, {id: number;data: BodyType<TicketUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTicket(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTicketMutationResult = NonNullable<Awaited<ReturnType<typeof updateTicket>>>
    export type UpdateTicketMutationBody = BodyType<TicketUpdate>
    export type UpdateTicketMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Update a ticket
 */
export const useUpdateTicket = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTicket>>, TError,{id: number;data: BodyType<TicketUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTicket>>,
        TError,
        {id: number;data: BodyType<TicketUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTicketMutationOptions(options));
    }

export const getCreateTicketMessageUrl = (id: number,) => {




  return `/api/tickets/${id}/messages`
}

/**
 * @summary Add a message to a ticket
 */
export const createTicketMessage = async (id: number,
    ticketMessageInput: TicketMessageInput, options?: RequestInit): Promise<TicketMessage> => {

  return customFetch<TicketMessage>(getCreateTicketMessageUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketMessageInput,)
  }
);}




export const getCreateTicketMessageMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTicketMessage>>, TError,{id: number;data: BodyType<TicketMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTicketMessage>>, TError,{id: number;data: BodyType<TicketMessageInput>}, TContext> => {

const mutationKey = ['createTicketMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTicketMessage>>, {id: number;data: BodyType<TicketMessageInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  createTicketMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTicketMessageMutationResult = NonNullable<Awaited<ReturnType<typeof createTicketMessage>>>
    export type CreateTicketMessageMutationBody = BodyType<TicketMessageInput>
    export type CreateTicketMessageMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Add a message to a ticket
 */
export const useCreateTicketMessage = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTicketMessage>>, TError,{id: number;data: BodyType<TicketMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTicketMessage>>,
        TError,
        {id: number;data: BodyType<TicketMessageInput>},
        TContext
      > => {
      return useMutation(getCreateTicketMessageMutationOptions(options));
    }

export const getListInfoSessionsUrl = (params?: ListInfoSessionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/info-sessions?${stringifiedParams}` : `/api/info-sessions`
}

/**
 * @summary List info sessions
 */
export const listInfoSessions = async (params?: ListInfoSessionsParams, options?: RequestInit): Promise<ListInfoSessions200> => {

  return customFetch<ListInfoSessions200>(getListInfoSessionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInfoSessionsQueryKey = (params?: ListInfoSessionsParams,) => {
    return [
    `/api/info-sessions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInfoSessionsQueryOptions = <TData = Awaited<ReturnType<typeof listInfoSessions>>, TError = ErrorType<unknown>>(params?: ListInfoSessionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInfoSessions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInfoSessionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInfoSessions>>> = ({ signal }) => listInfoSessions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInfoSessions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInfoSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listInfoSessions>>>
export type ListInfoSessionsQueryError = ErrorType<unknown>


/**
 * @summary List info sessions
 */

export function useListInfoSessions<TData = Awaited<ReturnType<typeof listInfoSessions>>, TError = ErrorType<unknown>>(
 params?: ListInfoSessionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInfoSessions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInfoSessionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateInfoSessionUrl = () => {




  return `/api/info-sessions`
}

/**
 * @summary Create an info session
 */
export const createInfoSession = async (infoSessionInput: InfoSessionInput, options?: RequestInit): Promise<InfoSession> => {

  return customFetch<InfoSession>(getCreateInfoSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      infoSessionInput,)
  }
);}




export const getCreateInfoSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInfoSession>>, TError,{data: BodyType<InfoSessionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInfoSession>>, TError,{data: BodyType<InfoSessionInput>}, TContext> => {

const mutationKey = ['createInfoSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInfoSession>>, {data: BodyType<InfoSessionInput>}> = (props) => {
          const {data} = props ?? {};

          return  createInfoSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInfoSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createInfoSession>>>
    export type CreateInfoSessionMutationBody = BodyType<InfoSessionInput>
    export type CreateInfoSessionMutationError = ErrorType<unknown>

    /**
 * @summary Create an info session
 */
export const useCreateInfoSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInfoSession>>, TError,{data: BodyType<InfoSessionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInfoSession>>,
        TError,
        {data: BodyType<InfoSessionInput>},
        TContext
      > => {
      return useMutation(getCreateInfoSessionMutationOptions(options));
    }

export const getGetInfoSessionUrl = (id: number,) => {




  return `/api/info-sessions/${id}`
}

/**
 * @summary Get an info session
 */
export const getInfoSession = async (id: number, options?: RequestInit): Promise<InfoSession> => {

  return customFetch<InfoSession>(getGetInfoSessionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInfoSessionQueryKey = (id: number,) => {
    return [
    `/api/info-sessions/${id}`
    ] as const;
    }


export const getGetInfoSessionQueryOptions = <TData = Awaited<ReturnType<typeof getInfoSession>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInfoSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInfoSessionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInfoSession>>> = ({ signal }) => getInfoSession(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInfoSession>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInfoSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getInfoSession>>>
export type GetInfoSessionQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get an info session
 */

export function useGetInfoSession<TData = Awaited<ReturnType<typeof getInfoSession>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInfoSession>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInfoSessionQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateInfoSessionUrl = (id: number,) => {




  return `/api/info-sessions/${id}`
}

/**
 * @summary Update an info session
 */
export const updateInfoSession = async (id: number,
    infoSessionUpdate: InfoSessionUpdate, options?: RequestInit): Promise<InfoSession> => {

  return customFetch<InfoSession>(getUpdateInfoSessionUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      infoSessionUpdate,)
  }
);}




export const getUpdateInfoSessionMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInfoSession>>, TError,{id: number;data: BodyType<InfoSessionUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInfoSession>>, TError,{id: number;data: BodyType<InfoSessionUpdate>}, TContext> => {

const mutationKey = ['updateInfoSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInfoSession>>, {id: number;data: BodyType<InfoSessionUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInfoSession(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInfoSessionMutationResult = NonNullable<Awaited<ReturnType<typeof updateInfoSession>>>
    export type UpdateInfoSessionMutationBody = BodyType<InfoSessionUpdate>
    export type UpdateInfoSessionMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Update an info session
 */
export const useUpdateInfoSession = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInfoSession>>, TError,{id: number;data: BodyType<InfoSessionUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInfoSession>>,
        TError,
        {id: number;data: BodyType<InfoSessionUpdate>},
        TContext
      > => {
      return useMutation(getUpdateInfoSessionMutationOptions(options));
    }

export const getListDataImportsUrl = (params?: ListDataImportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/data-imports?${stringifiedParams}` : `/api/data-imports`
}

/**
 * @summary List data imports
 */
export const listDataImports = async (params?: ListDataImportsParams, options?: RequestInit): Promise<ListDataImports200> => {

  return customFetch<ListDataImports200>(getListDataImportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDataImportsQueryKey = (params?: ListDataImportsParams,) => {
    return [
    `/api/data-imports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDataImportsQueryOptions = <TData = Awaited<ReturnType<typeof listDataImports>>, TError = ErrorType<unknown>>(params?: ListDataImportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDataImports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDataImportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataImports>>> = ({ signal }) => listDataImports(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDataImports>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDataImportsQueryResult = NonNullable<Awaited<ReturnType<typeof listDataImports>>>
export type ListDataImportsQueryError = ErrorType<unknown>


/**
 * @summary List data imports
 */

export function useListDataImports<TData = Awaited<ReturnType<typeof listDataImports>>, TError = ErrorType<unknown>>(
 params?: ListDataImportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDataImports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDataImportsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateDataImportUrl = () => {




  return `/api/data-imports`
}

/**
 * @summary Create a data import
 */
export const createDataImport = async (dataImportInput: DataImportInput, options?: RequestInit): Promise<DataImport> => {

  return customFetch<DataImport>(getCreateDataImportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      dataImportInput,)
  }
);}




export const getCreateDataImportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDataImport>>, TError,{data: BodyType<DataImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDataImport>>, TError,{data: BodyType<DataImportInput>}, TContext> => {

const mutationKey = ['createDataImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDataImport>>, {data: BodyType<DataImportInput>}> = (props) => {
          const {data} = props ?? {};

          return  createDataImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDataImportMutationResult = NonNullable<Awaited<ReturnType<typeof createDataImport>>>
    export type CreateDataImportMutationBody = BodyType<DataImportInput>
    export type CreateDataImportMutationError = ErrorType<unknown>

    /**
 * @summary Create a data import
 */
export const useCreateDataImport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDataImport>>, TError,{data: BodyType<DataImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDataImport>>,
        TError,
        {data: BodyType<DataImportInput>},
        TContext
      > => {
      return useMutation(getCreateDataImportMutationOptions(options));
    }

export const getGetDataImportUrl = (id: number,) => {




  return `/api/data-imports/${id}`
}

/**
 * @summary Get a data import
 */
export const getDataImport = async (id: number, options?: RequestInit): Promise<DataImport> => {

  return customFetch<DataImport>(getGetDataImportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDataImportQueryKey = (id: number,) => {
    return [
    `/api/data-imports/${id}`
    ] as const;
    }


export const getGetDataImportQueryOptions = <TData = Awaited<ReturnType<typeof getDataImport>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDataImport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataImportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataImport>>> = ({ signal }) => getDataImport(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataImport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDataImportQueryResult = NonNullable<Awaited<ReturnType<typeof getDataImport>>>
export type GetDataImportQueryError = ErrorType<NotFoundResponse>


/**
 * @summary Get a data import
 */

export function useGetDataImport<TData = Awaited<ReturnType<typeof getDataImport>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDataImport>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDataImportQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getProcessDataImportUrl = () => {




  return `/api/data-imports/process`
}

/**
 * Downloads a previously uploaded file from object storage, parses it
(CSV or XLSX), maps columns by kind, matches rows to existing orders
(leads) or agents (OMOO), applies order status updates for leads in a
transaction, records a data_imports row, and returns a summary plus the
parsed rows for display.

 * @summary Process an uploaded Openserve report (parse, match, apply, record)
 */
export const processDataImport = async (processDataImportInput: ProcessDataImportInput, options?: RequestInit): Promise<ProcessDataImportResult> => {

  return customFetch<ProcessDataImportResult>(getProcessDataImportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      processDataImportInput,)
  }
);}




export const getProcessDataImportMutationOptions = <TError = ErrorType<Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processDataImport>>, TError,{data: BodyType<ProcessDataImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof processDataImport>>, TError,{data: BodyType<ProcessDataImportInput>}, TContext> => {

const mutationKey = ['processDataImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processDataImport>>, {data: BodyType<ProcessDataImportInput>}> = (props) => {
          const {data} = props ?? {};

          return  processDataImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProcessDataImportMutationResult = NonNullable<Awaited<ReturnType<typeof processDataImport>>>
    export type ProcessDataImportMutationBody = BodyType<ProcessDataImportInput>
    export type ProcessDataImportMutationError = ErrorType<Error>

    /**
 * @summary Process an uploaded Openserve report (parse, match, apply, record)
 */
export const useProcessDataImport = <TError = ErrorType<Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processDataImport>>, TError,{data: BodyType<ProcessDataImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof processDataImport>>,
        TError,
        {data: BodyType<ProcessDataImportInput>},
        TContext
      > => {
      return useMutation(getProcessDataImportMutationOptions(options));
    }

export const getNotifyImportAgentsUrl = (id: number,) => {




  return `/api/data-imports/${id}/notify`
}

/**
 * Looks up the order status changes recorded for a processed Leads Report
import, groups them by agent, and sends each affected agent an in-app
notification (and an email, when an address is on file) summarizing what
moved in their pipeline. Idempotent: an import that has already been
notified is not notified again.

 * @summary Notify the agents whose orders changed in a processed import
 */
export const notifyImportAgents = async (id: number, options?: RequestInit): Promise<NotifyAgentsResult> => {

  return customFetch<NotifyAgentsResult>(getNotifyImportAgentsUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getNotifyImportAgentsMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyImportAgents>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof notifyImportAgents>>, TError,{id: number}, TContext> => {

const mutationKey = ['notifyImportAgents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyImportAgents>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  notifyImportAgents(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotifyImportAgentsMutationResult = NonNullable<Awaited<ReturnType<typeof notifyImportAgents>>>

    export type NotifyImportAgentsMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Notify the agents whose orders changed in a processed import
 */
export const useNotifyImportAgents = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyImportAgents>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof notifyImportAgents>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getNotifyImportAgentsMutationOptions(options));
    }

export const getListNotificationsUrl = () => {




  return `/api/notifications`
}

/**
 * @summary List the current user's in-app notifications
 */
export const listNotifications = async ( options?: RequestInit): Promise<Notification[]> => {

  return customFetch<Notification[]>(getListNotificationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationsQueryKey = () => {
    return [
    `/api/notifications`
    ] as const;
    }


export const getListNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) => listNotifications({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>
export type ListNotificationsQueryError = ErrorType<unknown>


/**
 * @summary List the current user's in-app notifications
 */

export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNotificationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getMarkNotificationReadUrl = (id: number,) => {




  return `/api/notifications/${id}/read`
}

/**
 * @summary Mark one of the current user's notifications as read
 */
export const markNotificationRead = async (id: number, options?: RequestInit): Promise<Notification> => {

  return customFetch<Notification>(getMarkNotificationReadUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getMarkNotificationReadMutationOptions = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext> => {

const mutationKey = ['markNotificationRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationRead>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  markNotificationRead(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationRead>>>

    export type MarkNotificationReadMutationError = ErrorType<NotFoundResponse>

    /**
 * @summary Mark one of the current user's notifications as read
 */
export const useMarkNotificationRead = <TError = ErrorType<NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationRead>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getMarkNotificationReadMutationOptions(options));
    }

export const getListNotificationChangesUrl = (id: number,) => {




  return `/api/notifications/${id}/changes`
}

/**
 * For a notification sourced from a Leads Report import, returns the order
status changes (reference, customer, previous → new status) that affected
the caller, so they can be taken straight to what moved in their pipeline.
Returns an empty list when the notification is not import-sourced.

 * @summary List the order status changes behind one of the current user's notifications
 */
export const listNotificationChanges = async (id: number, options?: RequestInit): Promise<ImportOrderChange[]> => {

  return customFetch<ImportOrderChange[]>(getListNotificationChangesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationChangesQueryKey = (id: number,) => {
    return [
    `/api/notifications/${id}/changes`
    ] as const;
    }


export const getListNotificationChangesQueryOptions = <TData = Awaited<ReturnType<typeof listNotificationChanges>>, TError = ErrorType<NotFoundResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotificationChanges>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationChangesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotificationChanges>>> = ({ signal }) => listNotificationChanges(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotificationChanges>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNotificationChangesQueryResult = NonNullable<Awaited<ReturnType<typeof listNotificationChanges>>>
export type ListNotificationChangesQueryError = ErrorType<NotFoundResponse>


/**
 * @summary List the order status changes behind one of the current user's notifications
 */

export function useListNotificationChanges<TData = Awaited<ReturnType<typeof listNotificationChanges>>, TError = ErrorType<NotFoundResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotificationChanges>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNotificationChangesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAuditLogsUrl = (params?: ListAuditLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/audit-logs?${stringifiedParams}` : `/api/audit-logs`
}

/**
 * @summary List audit log entries
 */
export const listAuditLogs = async (params?: ListAuditLogsParams, options?: RequestInit): Promise<ListAuditLogs200> => {

  return customFetch<ListAuditLogs200>(getListAuditLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditLogsQueryKey = (params?: ListAuditLogsParams,) => {
    return [
    `/api/audit-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>(params?: ListAuditLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLogs>>> = ({ signal }) => listAuditLogs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLogs>>>
export type ListAuditLogsQueryError = ErrorType<unknown>


/**
 * @summary List audit log entries
 */

export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>(
 params?: ListAuditLogsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAuditLogsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetMyOnboardingUrl = () => {




  return `/api/me/onboarding`
}

/**
 * @summary Get the current user's onboarding progress
 */
export const getMyOnboarding = async ( options?: RequestInit): Promise<Onboarding> => {

  return customFetch<Onboarding>(getGetMyOnboardingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyOnboardingQueryKey = () => {
    return [
    `/api/me/onboarding`
    ] as const;
    }


export const getGetMyOnboardingQueryOptions = <TData = Awaited<ReturnType<typeof getMyOnboarding>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyOnboarding>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyOnboardingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyOnboarding>>> = ({ signal }) => getMyOnboarding({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyOnboarding>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyOnboardingQueryResult = NonNullable<Awaited<ReturnType<typeof getMyOnboarding>>>
export type GetMyOnboardingQueryError = ErrorType<unknown>


/**
 * @summary Get the current user's onboarding progress
 */

export function useGetMyOnboarding<TData = Awaited<ReturnType<typeof getMyOnboarding>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyOnboarding>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyOnboardingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateMyOnboardingUrl = () => {




  return `/api/me/onboarding`
}

/**
 * @summary Persist partial onboarding progress
 */
export const updateMyOnboarding = async (updateOnboardingBody: UpdateOnboardingBody, options?: RequestInit): Promise<Onboarding> => {

  return customFetch<Onboarding>(getUpdateMyOnboardingUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOnboardingBody,)
  }
);}




export const getUpdateMyOnboardingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyOnboarding>>, TError,{data: BodyType<UpdateOnboardingBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyOnboarding>>, TError,{data: BodyType<UpdateOnboardingBody>}, TContext> => {

const mutationKey = ['updateMyOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyOnboarding>>, {data: BodyType<UpdateOnboardingBody>}> = (props) => {
          const {data} = props ?? {};

          return  updateMyOnboarding(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyOnboarding>>>
    export type UpdateMyOnboardingMutationBody = BodyType<UpdateOnboardingBody>
    export type UpdateMyOnboardingMutationError = ErrorType<unknown>

    /**
 * @summary Persist partial onboarding progress
 */
export const useUpdateMyOnboarding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyOnboarding>>, TError,{data: BodyType<UpdateOnboardingBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMyOnboarding>>,
        TError,
        {data: BodyType<UpdateOnboardingBody>},
        TContext
      > => {
      return useMutation(getUpdateMyOnboardingMutationOptions(options));
    }

export const getSubmitMyOnboardingUrl = () => {




  return `/api/me/onboarding/submit`
}

/**
 * @summary Submit completed onboarding for review
 */
export const submitMyOnboarding = async ( options?: RequestInit): Promise<Onboarding> => {

  return customFetch<Onboarding>(getSubmitMyOnboardingUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSubmitMyOnboardingMutationOptions = <TError = ErrorType<Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitMyOnboarding>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitMyOnboarding>>, TError,void, TContext> => {

const mutationKey = ['submitMyOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitMyOnboarding>>, void> = () => {


          return  submitMyOnboarding(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitMyOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof submitMyOnboarding>>>

    export type SubmitMyOnboardingMutationError = ErrorType<Error>

    /**
 * @summary Submit completed onboarding for review
 */
export const useSubmitMyOnboarding = <TError = ErrorType<Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitMyOnboarding>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitMyOnboarding>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSubmitMyOnboardingMutationOptions(options));
    }

export const getGetMyMsaUrl = () => {




  return `/api/me/msa`
}

/**
 * @summary Get the current agent's Field Sales Agent Agreement status
 */
export const getMyMsa = async ( options?: RequestInit): Promise<MsaStatus> => {

  return customFetch<MsaStatus>(getGetMyMsaUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyMsaQueryKey = () => {
    return [
    `/api/me/msa`
    ] as const;
    }


export const getGetMyMsaQueryOptions = <TData = Awaited<ReturnType<typeof getMyMsa>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyMsa>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyMsaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyMsa>>> = ({ signal }) => getMyMsa({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyMsa>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyMsaQueryResult = NonNullable<Awaited<ReturnType<typeof getMyMsa>>>
export type GetMyMsaQueryError = ErrorType<unknown>


/**
 * @summary Get the current agent's Field Sales Agent Agreement status
 */

export function useGetMyMsa<TData = Awaited<ReturnType<typeof getMyMsa>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyMsa>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyMsaQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSignMyMsaUrl = () => {




  return `/api/me/msa/sign`
}

/**
 * @summary Agent digitally signs the Field Sales Agent Agreement
 */
export const signMyMsa = async (msaSignBody: MsaSignBody, options?: RequestInit): Promise<MsaStatus> => {

  return customFetch<MsaStatus>(getSignMyMsaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      msaSignBody,)
  }
);}




export const getSignMyMsaMutationOptions = <TError = ErrorType<Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signMyMsa>>, TError,{data: BodyType<MsaSignBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof signMyMsa>>, TError,{data: BodyType<MsaSignBody>}, TContext> => {

const mutationKey = ['signMyMsa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signMyMsa>>, {data: BodyType<MsaSignBody>}> = (props) => {
          const {data} = props ?? {};

          return  signMyMsa(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignMyMsaMutationResult = NonNullable<Awaited<ReturnType<typeof signMyMsa>>>
    export type SignMyMsaMutationBody = BodyType<MsaSignBody>
    export type SignMyMsaMutationError = ErrorType<Error>

    /**
 * @summary Agent digitally signs the Field Sales Agent Agreement
 */
export const useSignMyMsa = <TError = ErrorType<Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signMyMsa>>, TError,{data: BodyType<MsaSignBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof signMyMsa>>,
        TError,
        {data: BodyType<MsaSignBody>},
        TContext
      > => {
      return useMutation(getSignMyMsaMutationOptions(options));
    }

export const getRequestUploadUrlUrl = () => {




  return `/api/storage/uploads/request-url`
}

/**
 * Returns a presigned GCS URL for direct upload. The client sends JSON
metadata here, then uploads the file directly to the returned URL.

 * @summary Request a presigned URL for file upload
 */
export const requestUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: RequestInit): Promise<UploadUrlResponse> => {

  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      uploadUrlRequest,)
  }
);}




export const getRequestUploadUrlMutationOptions = <TError = ErrorType<Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext> => {

const mutationKey = ['requestUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUploadUrl>>, {data: BodyType<UploadUrlRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestUploadUrl>>>
    export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestUploadUrlMutationError = ErrorType<Error>

    /**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <TError = ErrorType<Error>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestUploadUrl>>,
        TError,
        {data: BodyType<UploadUrlRequest>},
        TContext
      > => {
      return useMutation(getRequestUploadUrlMutationOptions(options));
    }

export const getGetPublicObjectUrl = (filePath: string,) => {




  return `/api/storage/public-objects/${filePath}`
}

/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */
export const getPublicObject = async (filePath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetPublicObjectUrl(filePath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicObjectQueryKey = (filePath: string,) => {
    return [
    `/api/storage/public-objects/${filePath}`
    ] as const;
    }


export const getGetPublicObjectQueryOptions = <TData = Awaited<ReturnType<typeof getPublicObject>>, TError = ErrorType<Error>>(filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({ signal }) => getPublicObject(filePath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(filePath), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicObject>>>
export type GetPublicObjectQueryError = ErrorType<Error>


/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */

export function useGetPublicObject<TData = Awaited<ReturnType<typeof getPublicObject>>, TError = ErrorType<Error>>(
 filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicObjectQueryOptions(filePath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetStorageObjectUrl = (objectPath: string,) => {




  return `/api/storage/objects/${objectPath}`
}

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getStorageObject = async (objectPath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetStorageObjectUrl(objectPath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorageObjectQueryKey = (objectPath: string,) => {
    return [
    `/api/storage/objects/${objectPath}`
    ] as const;
    }


export const getGetStorageObjectQueryOptions = <TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<Error>>(objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageObject>>> = ({ signal }) => getStorageObject(objectPath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(objectPath), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorageObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getStorageObject>>>
export type GetStorageObjectQueryError = ErrorType<Error>


/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<Error>>(
 objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorageObjectQueryOptions(objectPath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListMarketingMaterialsUrl = (params?: ListMarketingMaterialsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/marketing-materials?${stringifiedParams}` : `/api/marketing-materials`
}

/**
 * @summary List marketing materials (all roles)
 */
export const listMarketingMaterials = async (params?: ListMarketingMaterialsParams, options?: RequestInit): Promise<ListMarketingMaterials200> => {

  return customFetch<ListMarketingMaterials200>(getListMarketingMaterialsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMarketingMaterialsQueryKey = (params?: ListMarketingMaterialsParams,) => {
    return [
    `/api/marketing-materials`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMarketingMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof listMarketingMaterials>>, TError = ErrorType<unknown>>(params?: ListMarketingMaterialsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMarketingMaterials>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMarketingMaterialsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMarketingMaterials>>> = ({ signal }) => listMarketingMaterials(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMarketingMaterials>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMarketingMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof listMarketingMaterials>>>
export type ListMarketingMaterialsQueryError = ErrorType<unknown>


/**
 * @summary List marketing materials (all roles)
 */

export function useListMarketingMaterials<TData = Awaited<ReturnType<typeof listMarketingMaterials>>, TError = ErrorType<unknown>>(
 params?: ListMarketingMaterialsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMarketingMaterials>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMarketingMaterialsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateMarketingMaterialUrl = () => {




  return `/api/marketing-materials`
}

/**
 * @summary Add a marketing material (staff only)
 */
export const createMarketingMaterial = async (marketingMaterialInput: MarketingMaterialInput, options?: RequestInit): Promise<MarketingMaterial> => {

  return customFetch<MarketingMaterial>(getCreateMarketingMaterialUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      marketingMaterialInput,)
  }
);}




export const getCreateMarketingMaterialMutationOptions = <TError = ErrorType<ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMarketingMaterial>>, TError,{data: BodyType<MarketingMaterialInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMarketingMaterial>>, TError,{data: BodyType<MarketingMaterialInput>}, TContext> => {

const mutationKey = ['createMarketingMaterial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMarketingMaterial>>, {data: BodyType<MarketingMaterialInput>}> = (props) => {
          const {data} = props ?? {};

          return  createMarketingMaterial(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMarketingMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof createMarketingMaterial>>>
    export type CreateMarketingMaterialMutationBody = BodyType<MarketingMaterialInput>
    export type CreateMarketingMaterialMutationError = ErrorType<ForbiddenResponse>

    /**
 * @summary Add a marketing material (staff only)
 */
export const useCreateMarketingMaterial = <TError = ErrorType<ForbiddenResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMarketingMaterial>>, TError,{data: BodyType<MarketingMaterialInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMarketingMaterial>>,
        TError,
        {data: BodyType<MarketingMaterialInput>},
        TContext
      > => {
      return useMutation(getCreateMarketingMaterialMutationOptions(options));
    }

export const getDeleteMarketingMaterialUrl = (id: number,) => {




  return `/api/marketing-materials/${id}`
}

/**
 * @summary Delete a marketing material (staff only)
 */
export const deleteMarketingMaterial = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteMarketingMaterialUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteMarketingMaterialMutationOptions = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingMaterial>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingMaterial>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteMarketingMaterial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMarketingMaterial>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteMarketingMaterial(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMarketingMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMarketingMaterial>>>

    export type DeleteMarketingMaterialMutationError = ErrorType<ForbiddenResponse | NotFoundResponse>

    /**
 * @summary Delete a marketing material (staff only)
 */
export const useDeleteMarketingMaterial = <TError = ErrorType<ForbiddenResponse | NotFoundResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingMaterial>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMarketingMaterial>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteMarketingMaterialMutationOptions(options));
    }

